/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const acceptInviteLink = /* GraphQL */ `
  mutation AcceptInviteLink($inviteCode: String, $status: UserAuthRoleStatus) {
    acceptInviteLink(inviteCode: $inviteCode, status: $status)
  }
`;
export const sendInviteLink = /* GraphQL */ `
  mutation SendInviteLink($userAuthRoleId: ID!) {
    sendInviteLink(userAuthRoleId: $userAuthRoleId)
  }
`;
export const revokeInvite = /* GraphQL */ `
  mutation RevokeInvite($inviteId: String) {
    revokeInvite(inviteId: $inviteId)
  }
`;
export const setUpAccount = /* GraphQL */ `
  mutation SetUpAccount($input: SetUpAccountInput) {
    setUpAccount(input: $input)
  }
`;
export const verifyAccount = /* GraphQL */ `
  mutation VerifyAccount($input: SetUpAccountInput) {
    verifyAccount(input: $input)
  }
`;
export const setAccountInfo = /* GraphQL */ `
  mutation SetAccountInfo($input: SetAccountInfoInput) {
    setAccountInfo(input: $input)
  }
`;
export const requestSupport = /* GraphQL */ `
  mutation RequestSupport($input: RequestSupportInput) {
    requestSupport(input: $input)
  }
`;
export const updateAccountSettings = /* GraphQL */ `
  mutation UpdateAccountSettings($input: UpdateAccountSettingsInput) {
    updateAccountSettings(input: $input)
  }
`;
export const instrumentError = /* GraphQL */ `
  mutation InstrumentError($input: InstrumentErrorInput) {
    instrumentError(input: $input)
  }
`;
export const verifyPixel = /* GraphQL */ `
  mutation VerifyPixel($brandId: ID!) {
    verifyPixel(brandId: $brandId)
  }
`;
export const updateBrandProtected = /* GraphQL */ `
  mutation UpdateBrandProtected($input: UpdateProtectedFieldsInput) {
    updateBrandProtected(input: $input) {
      id
      config
      accountConfig
      accountSettings
      paymentMethods {
        items {
          stripeId
          nickname
          lastFour
          cardType
          default
          __typename
        }
        __typename
      }
      oMar
      tMar
      bMar
      __typename
    }
  }
`;
export const setUpBrand = /* GraphQL */ `
  mutation SetUpBrand($input: SetUpBrandInput) {
    setUpBrand(input: $input)
  }
`;
export const addTrackingTag = /* GraphQL */ `
  mutation AddTrackingTag($input: AddTrackingTagInput) {
    addTrackingTag(input: $input)
  }
`;
export const addFirstPartyTrackingTag = /* GraphQL */ `
  mutation AddFirstPartyTrackingTag($input: AddTrackingTagInput) {
    addFirstPartyTrackingTag(input: $input)
  }
`;
export const addCustomTrackingTag = /* GraphQL */ `
  mutation AddCustomTrackingTag($input: AddTrackingTagInput) {
    addCustomTrackingTag(input: $input)
  }
`;
export const addUniversalTrackingTag = /* GraphQL */ `
  mutation AddUniversalTrackingTag($input: AddUniversalTrackingTagInput) {
    addUniversalTrackingTag(input: $input)
  }
`;
export const updateUniversalPixel = /* GraphQL */ `
  mutation UpdateUniversalPixel($input: UpdateUniversalPixelInput) {
    updateUniversalPixel(input: $input)
  }
`;
export const createPaymentIntent = /* GraphQL */ `
  mutation CreatePaymentIntent($input: PaymentIntentInput) {
    createPaymentIntent(input: $input)
  }
`;
export const transferCredits = /* GraphQL */ `
  mutation TransferCredits($input: PaymentIntentInput) {
    transferCredits(input: $input)
  }
`;
export const addCredits = /* GraphQL */ `
  mutation AddCredits($input: PaymentIntentInput) {
    addCredits(input: $input)
  }
`;
export const adminAddCredits = /* GraphQL */ `
  mutation AdminAddCredits($input: AdminPaymentIntentInput) {
    adminAddCredits(input: $input)
  }
`;
export const createSetupIntent = /* GraphQL */ `
  mutation CreateSetupIntent($input: CreateSetupIntentInput) {
    createSetupIntent(input: $input)
  }
`;
export const addPaymentMethod = /* GraphQL */ `
  mutation AddPaymentMethod($input: CreateSetupIntentInput) {
    addPaymentMethod(input: $input)
  }
`;
export const removePaymentMethod = /* GraphQL */ `
  mutation RemovePaymentMethod($input: RemovePaymentMethodInput) {
    removePaymentMethod(input: $input)
  }
`;
export const listPaymentMethods = /* GraphQL */ `
  mutation ListPaymentMethods($input: ListPaymentMethodsInput) {
    listPaymentMethods(input: $input)
  }
`;
export const createStripeCustomer = /* GraphQL */ `
  mutation CreateStripeCustomer($input: CreateStripeCustomerInput) {
    createStripeCustomer(input: $input)
  }
`;
export const campaignService = /* GraphQL */ `
  mutation CampaignService(
    $action: CampaignAction
    $campaignId: ID
    $payload: AWSJSON
  ) {
    campaignService(
      action: $action
      campaignId: $campaignId
      payload: $payload
    ) {
      message
      campaign {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        stoppedAt
        approvedAt
        lastRecurredAt
        organizationId
        teamId
        brandId
        brand {
          id
          archived
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          organizationId
          teamId
          team {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          advertiserId
          name
          websiteUrl
          logoUrl
          industryCategoryId
          politicalSettings {
            politicalType
            electionType
            status
            __typename
          }
          campaignPostProcessors
          config
          availableCredits
          paymentMethods {
            __typename
          }
          bMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          universalPixel {
            UniversalPixelId
            UniversalPixelName
            AdvertiserId
            __typename
          }
          pixelCode
          pixelTracking
          pixelAudienceSize
          pixelMappingSizes
          theme {
            primary
            secondary
            pallet
            __typename
          }
          campaignSummary {
            running
            stopped
            completed
            __typename
          }
          creativeSummary {
            audio
            display
            video
            __typename
          }
          reportSummary {
            forecast
            summary
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          campaigns {
            nextToken
            __typename
          }
          trackingTags {
            nextToken
            __typename
          }
          isValid
          error
          defaultStripeId
          underReview
          teamBrandsId
          __typename
        }
        status
        recurrenceWindow
        recurrenceBudget
        name
        goal
        budget
        originalBudget
        dailyBudget
        startDate
        endDate
        originalEndDate
        audienceType
        audienceFrom
        retargetingTags {
          dspId
          firstPartyDataId
          trackingTagId
          __typename
        }
        geoSegments {
          id
          segmentPackageId
          dspId
          name
          pathKey
          segmentType
          segmentGroup
          __typename
        }
        dmpSegments {
          id
          segmentPackageId
          dspId
          name
          pathKey
          segmentType
          segmentGroup
          __typename
        }
        inventorySegments {
          id
          segmentPackageId
          dspId
          name
          pathKey
          segmentType
          segmentGroup
          __typename
        }
        timesOfDay
        daysOfWeek
        creatives {
          items {
            id
            archived
            createdAt
            updatedAt
            uploadedAt
            publishedAt
            adminGroups
            viewerGroups
            organizationId
            teamBrandCampaign
            teamId
            brandId
            campaignId
            teamBrandCampaignId
            name
            fileName
            creativeType
            s3Key
            s3ThumbnailKey
            clickthroughUrl
            landingPageUrl
            inApp
            web
            ctv
            displayTargeting
            devices
            dspIds
            ttdId
            ttdStatus
            isValid
            error
            campaignCreativesId
            __typename
          }
          nextToken
          __typename
        }
        forecastRequestedAt
        forecastAdgroups
        publishedAt
        forecast {
          requestedAt
          createdAt
          impressions {
            max
            min
            __typename
          }
          reach {
            max
            min
            __typename
          }
          frequency {
            max
            min
            __typename
          }
          spend {
            max
            min
            __typename
          }
          results {
            adgroupType
            __typename
          }
          __typename
        }
        ttdId
        conversionsEnabled
        trackingTagId
        pixelTrackingUrl
        conversionEvents {
          type
          id
          __typename
        }
        ttdStatus
        dspIds
        audience
        bidlists
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        ttdUpdatedAt
        activeUpdatedAt
        sfOpportunityId
        ctvSegments
        isRecurring
        isValid
        error
        isMultiDataGroups
        campaignPoliticalSettings {
          type
          __typename
        }
        additionalBidLists
        postProcessors
        brandCampaignsId
        __typename
      }
      __typename
    }
  }
`;
export const generateApiKey = /* GraphQL */ `
  mutation GenerateApiKey($input: GenerateApiKeyInput) {
    generateApiKey(input: $input)
  }
`;
export const queueCampaignSitesReport = /* GraphQL */ `
  mutation QueueCampaignSitesReport($input: GenerateCampaignSitesReportInput) {
    queueCampaignSitesReport(input: $input)
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      cognitoId
      userId
      authGroup
      createdAt
      updatedAt
      selectedAuth
      firstName
      lastName
      profileImageUrl
      hasBeenWelcomed
      email
      authRoles {
        items {
          id
          createdAt
          updatedAt
          adminGroups
          viewerGroups
          status
          email
          userId
          authRole
          staticAuthRole
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          teamId
          team {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          brandId
          brand {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          inviteCode
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      cognitoId
      userId
      authGroup
      createdAt
      updatedAt
      selectedAuth
      firstName
      lastName
      profileImageUrl
      hasBeenWelcomed
      email
      authRoles {
        items {
          id
          createdAt
          updatedAt
          adminGroups
          viewerGroups
          status
          email
          userId
          authRole
          staticAuthRole
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          teamId
          team {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          brandId
          brand {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          inviteCode
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      cognitoId
      userId
      authGroup
      createdAt
      updatedAt
      selectedAuth
      firstName
      lastName
      profileImageUrl
      hasBeenWelcomed
      email
      authRoles {
        items {
          id
          createdAt
          updatedAt
          adminGroups
          viewerGroups
          status
          email
          userId
          authRole
          staticAuthRole
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          teamId
          team {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          brandId
          brand {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          inviteCode
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createUserAuthRole = /* GraphQL */ `
  mutation CreateUserAuthRole(
    $input: CreateUserAuthRoleInput!
    $condition: ModelUserAuthRoleConditionInput
  ) {
    createUserAuthRole(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      adminGroups
      viewerGroups
      status
      email
      userId
      authRole
      staticAuthRole
      organizationId
      organization {
        id
        archived
        adminGroups
        viewerGroups
        memberGroups
        createdAt
        updatedAt
        name
        logoUrl
        accountDomain
        accountSubdomain
        accountInfo {
          owner
          ownerEmail
          website
          companyRole
          companyLocation
          companySize
          referencedBy
          industryCategoryId
          sfAccountId
          sfContactId
          sfOwnerId
          ownerPhoneNumber
          __typename
        }
        theme {
          primary
          secondary
          pallet
          __typename
        }
        accountConfig
        config
        accountSettings {
          accountType
          accountTier
          onboardingStatus
          teamId
          brandId
          role
          companySize
          address {
            street
            unitNumber
            city
            state
            postalCode
            country
            __typename
          }
          __typename
        }
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        oMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        defaultTeamMarkup
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        teams {
          items {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          nextToken
          __typename
        }
        whitelabelConfig {
          disableBrandCreditSelfService
          __typename
        }
        overrides {
          minimumCampaignBudget
          __typename
        }
        __typename
      }
      teamId
      team {
        id
        archived
        adminGroups
        viewerGroups
        memberGroups
        createdAt
        updatedAt
        organizationId
        organization {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          name
          logoUrl
          accountDomain
          accountSubdomain
          accountInfo {
            owner
            ownerEmail
            website
            companyRole
            companyLocation
            companySize
            referencedBy
            industryCategoryId
            sfAccountId
            sfContactId
            sfOwnerId
            ownerPhoneNumber
            __typename
          }
          theme {
            primary
            secondary
            pallet
            __typename
          }
          accountConfig
          config
          accountSettings {
            accountType
            accountTier
            onboardingStatus
            teamId
            brandId
            role
            companySize
            __typename
          }
          availableCredits
          paymentMethods {
            __typename
          }
          oMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultTeamMarkup
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          teams {
            nextToken
            __typename
          }
          whitelabelConfig {
            disableBrandCreditSelfService
            __typename
          }
          overrides {
            minimumCampaignBudget
            __typename
          }
          __typename
        }
        name
        websiteUrl
        logoUrl
        industryCategoryId
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        tMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        defaultBrandMarkup
        theme {
          primary
          secondary
          pallet
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        brands {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          nextToken
          __typename
        }
        defaultStripeId
        organizationTeamsId
        __typename
      }
      brandId
      brand {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        organizationId
        teamId
        team {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          name
          websiteUrl
          logoUrl
          industryCategoryId
          config
          availableCredits
          paymentMethods {
            __typename
          }
          tMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultBrandMarkup
          theme {
            primary
            secondary
            pallet
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          brands {
            nextToken
            __typename
          }
          defaultStripeId
          organizationTeamsId
          __typename
        }
        advertiserId
        name
        websiteUrl
        logoUrl
        industryCategoryId
        politicalSettings {
          politicalType
          electionType
          candidate {
            PoliticalDataId
            CandidateName
            ElectionState
            PayingEntityName
            PayingEntityAddress
            PayingEntityEmailAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            GeoDescription
            AudienceDescription
            DisclaimerNotice
            FileLocationInS3
            FederalVerificationId
            StateVerificationId
            IsAdvertiserIEC
            __typename
          }
          status
          ballotMeasureProfile {
            PayingEntityName
            PayingEntityAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            ElectionState
            __typename
          }
          __typename
        }
        campaignPostProcessors
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        bMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        universalPixel {
          UniversalPixelMappings {
            __typename
          }
          UniversalPixelId
          UniversalPixelName
          AdvertiserId
          __typename
        }
        pixelCode
        pixelTracking
        pixelAudienceSize
        pixelMappingSizes
        theme {
          primary
          secondary
          pallet
          __typename
        }
        campaignSummary {
          running
          stopped
          completed
          __typename
        }
        creativeSummary {
          audio
          display
          video
          __typename
        }
        reportSummary {
          forecast
          summary
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        campaigns {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            stoppedAt
            approvedAt
            lastRecurredAt
            organizationId
            teamId
            brandId
            status
            recurrenceWindow
            recurrenceBudget
            name
            goal
            budget
            originalBudget
            dailyBudget
            startDate
            endDate
            originalEndDate
            audienceType
            audienceFrom
            timesOfDay
            daysOfWeek
            forecastRequestedAt
            forecastAdgroups
            publishedAt
            ttdId
            conversionsEnabled
            trackingTagId
            pixelTrackingUrl
            ttdStatus
            dspIds
            audience
            bidlists
            ttdUpdatedAt
            activeUpdatedAt
            sfOpportunityId
            ctvSegments
            isRecurring
            isValid
            error
            isMultiDataGroups
            additionalBidLists
            postProcessors
            brandCampaignsId
            __typename
          }
          nextToken
          __typename
        }
        trackingTags {
          items {
            id
            archived
            trackingTagType
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            errorNotifiedAt
            organizationId
            teamId
            brandId
            dspIds
            status
            ttdId
            name
            pixelCode
            pixelAudienceSize
            pixelUrl
            remainingDays
            piiType
            region
            retainPii
            brandTrackingTagsId
            __typename
          }
          nextToken
          __typename
        }
        isValid
        error
        defaultStripeId
        underReview
        teamBrandsId
        __typename
      }
      inviteCode
      __typename
    }
  }
`;
export const updateUserAuthRole = /* GraphQL */ `
  mutation UpdateUserAuthRole(
    $input: UpdateUserAuthRoleInput!
    $condition: ModelUserAuthRoleConditionInput
  ) {
    updateUserAuthRole(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      adminGroups
      viewerGroups
      status
      email
      userId
      authRole
      staticAuthRole
      organizationId
      organization {
        id
        archived
        adminGroups
        viewerGroups
        memberGroups
        createdAt
        updatedAt
        name
        logoUrl
        accountDomain
        accountSubdomain
        accountInfo {
          owner
          ownerEmail
          website
          companyRole
          companyLocation
          companySize
          referencedBy
          industryCategoryId
          sfAccountId
          sfContactId
          sfOwnerId
          ownerPhoneNumber
          __typename
        }
        theme {
          primary
          secondary
          pallet
          __typename
        }
        accountConfig
        config
        accountSettings {
          accountType
          accountTier
          onboardingStatus
          teamId
          brandId
          role
          companySize
          address {
            street
            unitNumber
            city
            state
            postalCode
            country
            __typename
          }
          __typename
        }
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        oMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        defaultTeamMarkup
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        teams {
          items {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          nextToken
          __typename
        }
        whitelabelConfig {
          disableBrandCreditSelfService
          __typename
        }
        overrides {
          minimumCampaignBudget
          __typename
        }
        __typename
      }
      teamId
      team {
        id
        archived
        adminGroups
        viewerGroups
        memberGroups
        createdAt
        updatedAt
        organizationId
        organization {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          name
          logoUrl
          accountDomain
          accountSubdomain
          accountInfo {
            owner
            ownerEmail
            website
            companyRole
            companyLocation
            companySize
            referencedBy
            industryCategoryId
            sfAccountId
            sfContactId
            sfOwnerId
            ownerPhoneNumber
            __typename
          }
          theme {
            primary
            secondary
            pallet
            __typename
          }
          accountConfig
          config
          accountSettings {
            accountType
            accountTier
            onboardingStatus
            teamId
            brandId
            role
            companySize
            __typename
          }
          availableCredits
          paymentMethods {
            __typename
          }
          oMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultTeamMarkup
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          teams {
            nextToken
            __typename
          }
          whitelabelConfig {
            disableBrandCreditSelfService
            __typename
          }
          overrides {
            minimumCampaignBudget
            __typename
          }
          __typename
        }
        name
        websiteUrl
        logoUrl
        industryCategoryId
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        tMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        defaultBrandMarkup
        theme {
          primary
          secondary
          pallet
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        brands {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          nextToken
          __typename
        }
        defaultStripeId
        organizationTeamsId
        __typename
      }
      brandId
      brand {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        organizationId
        teamId
        team {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          name
          websiteUrl
          logoUrl
          industryCategoryId
          config
          availableCredits
          paymentMethods {
            __typename
          }
          tMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultBrandMarkup
          theme {
            primary
            secondary
            pallet
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          brands {
            nextToken
            __typename
          }
          defaultStripeId
          organizationTeamsId
          __typename
        }
        advertiserId
        name
        websiteUrl
        logoUrl
        industryCategoryId
        politicalSettings {
          politicalType
          electionType
          candidate {
            PoliticalDataId
            CandidateName
            ElectionState
            PayingEntityName
            PayingEntityAddress
            PayingEntityEmailAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            GeoDescription
            AudienceDescription
            DisclaimerNotice
            FileLocationInS3
            FederalVerificationId
            StateVerificationId
            IsAdvertiserIEC
            __typename
          }
          status
          ballotMeasureProfile {
            PayingEntityName
            PayingEntityAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            ElectionState
            __typename
          }
          __typename
        }
        campaignPostProcessors
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        bMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        universalPixel {
          UniversalPixelMappings {
            __typename
          }
          UniversalPixelId
          UniversalPixelName
          AdvertiserId
          __typename
        }
        pixelCode
        pixelTracking
        pixelAudienceSize
        pixelMappingSizes
        theme {
          primary
          secondary
          pallet
          __typename
        }
        campaignSummary {
          running
          stopped
          completed
          __typename
        }
        creativeSummary {
          audio
          display
          video
          __typename
        }
        reportSummary {
          forecast
          summary
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        campaigns {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            stoppedAt
            approvedAt
            lastRecurredAt
            organizationId
            teamId
            brandId
            status
            recurrenceWindow
            recurrenceBudget
            name
            goal
            budget
            originalBudget
            dailyBudget
            startDate
            endDate
            originalEndDate
            audienceType
            audienceFrom
            timesOfDay
            daysOfWeek
            forecastRequestedAt
            forecastAdgroups
            publishedAt
            ttdId
            conversionsEnabled
            trackingTagId
            pixelTrackingUrl
            ttdStatus
            dspIds
            audience
            bidlists
            ttdUpdatedAt
            activeUpdatedAt
            sfOpportunityId
            ctvSegments
            isRecurring
            isValid
            error
            isMultiDataGroups
            additionalBidLists
            postProcessors
            brandCampaignsId
            __typename
          }
          nextToken
          __typename
        }
        trackingTags {
          items {
            id
            archived
            trackingTagType
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            errorNotifiedAt
            organizationId
            teamId
            brandId
            dspIds
            status
            ttdId
            name
            pixelCode
            pixelAudienceSize
            pixelUrl
            remainingDays
            piiType
            region
            retainPii
            brandTrackingTagsId
            __typename
          }
          nextToken
          __typename
        }
        isValid
        error
        defaultStripeId
        underReview
        teamBrandsId
        __typename
      }
      inviteCode
      __typename
    }
  }
`;
export const deleteUserAuthRole = /* GraphQL */ `
  mutation DeleteUserAuthRole(
    $input: DeleteUserAuthRoleInput!
    $condition: ModelUserAuthRoleConditionInput
  ) {
    deleteUserAuthRole(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      adminGroups
      viewerGroups
      status
      email
      userId
      authRole
      staticAuthRole
      organizationId
      organization {
        id
        archived
        adminGroups
        viewerGroups
        memberGroups
        createdAt
        updatedAt
        name
        logoUrl
        accountDomain
        accountSubdomain
        accountInfo {
          owner
          ownerEmail
          website
          companyRole
          companyLocation
          companySize
          referencedBy
          industryCategoryId
          sfAccountId
          sfContactId
          sfOwnerId
          ownerPhoneNumber
          __typename
        }
        theme {
          primary
          secondary
          pallet
          __typename
        }
        accountConfig
        config
        accountSettings {
          accountType
          accountTier
          onboardingStatus
          teamId
          brandId
          role
          companySize
          address {
            street
            unitNumber
            city
            state
            postalCode
            country
            __typename
          }
          __typename
        }
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        oMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        defaultTeamMarkup
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        teams {
          items {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          nextToken
          __typename
        }
        whitelabelConfig {
          disableBrandCreditSelfService
          __typename
        }
        overrides {
          minimumCampaignBudget
          __typename
        }
        __typename
      }
      teamId
      team {
        id
        archived
        adminGroups
        viewerGroups
        memberGroups
        createdAt
        updatedAt
        organizationId
        organization {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          name
          logoUrl
          accountDomain
          accountSubdomain
          accountInfo {
            owner
            ownerEmail
            website
            companyRole
            companyLocation
            companySize
            referencedBy
            industryCategoryId
            sfAccountId
            sfContactId
            sfOwnerId
            ownerPhoneNumber
            __typename
          }
          theme {
            primary
            secondary
            pallet
            __typename
          }
          accountConfig
          config
          accountSettings {
            accountType
            accountTier
            onboardingStatus
            teamId
            brandId
            role
            companySize
            __typename
          }
          availableCredits
          paymentMethods {
            __typename
          }
          oMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultTeamMarkup
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          teams {
            nextToken
            __typename
          }
          whitelabelConfig {
            disableBrandCreditSelfService
            __typename
          }
          overrides {
            minimumCampaignBudget
            __typename
          }
          __typename
        }
        name
        websiteUrl
        logoUrl
        industryCategoryId
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        tMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        defaultBrandMarkup
        theme {
          primary
          secondary
          pallet
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        brands {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          nextToken
          __typename
        }
        defaultStripeId
        organizationTeamsId
        __typename
      }
      brandId
      brand {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        organizationId
        teamId
        team {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          name
          websiteUrl
          logoUrl
          industryCategoryId
          config
          availableCredits
          paymentMethods {
            __typename
          }
          tMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultBrandMarkup
          theme {
            primary
            secondary
            pallet
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          brands {
            nextToken
            __typename
          }
          defaultStripeId
          organizationTeamsId
          __typename
        }
        advertiserId
        name
        websiteUrl
        logoUrl
        industryCategoryId
        politicalSettings {
          politicalType
          electionType
          candidate {
            PoliticalDataId
            CandidateName
            ElectionState
            PayingEntityName
            PayingEntityAddress
            PayingEntityEmailAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            GeoDescription
            AudienceDescription
            DisclaimerNotice
            FileLocationInS3
            FederalVerificationId
            StateVerificationId
            IsAdvertiserIEC
            __typename
          }
          status
          ballotMeasureProfile {
            PayingEntityName
            PayingEntityAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            ElectionState
            __typename
          }
          __typename
        }
        campaignPostProcessors
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        bMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        universalPixel {
          UniversalPixelMappings {
            __typename
          }
          UniversalPixelId
          UniversalPixelName
          AdvertiserId
          __typename
        }
        pixelCode
        pixelTracking
        pixelAudienceSize
        pixelMappingSizes
        theme {
          primary
          secondary
          pallet
          __typename
        }
        campaignSummary {
          running
          stopped
          completed
          __typename
        }
        creativeSummary {
          audio
          display
          video
          __typename
        }
        reportSummary {
          forecast
          summary
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        campaigns {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            stoppedAt
            approvedAt
            lastRecurredAt
            organizationId
            teamId
            brandId
            status
            recurrenceWindow
            recurrenceBudget
            name
            goal
            budget
            originalBudget
            dailyBudget
            startDate
            endDate
            originalEndDate
            audienceType
            audienceFrom
            timesOfDay
            daysOfWeek
            forecastRequestedAt
            forecastAdgroups
            publishedAt
            ttdId
            conversionsEnabled
            trackingTagId
            pixelTrackingUrl
            ttdStatus
            dspIds
            audience
            bidlists
            ttdUpdatedAt
            activeUpdatedAt
            sfOpportunityId
            ctvSegments
            isRecurring
            isValid
            error
            isMultiDataGroups
            additionalBidLists
            postProcessors
            brandCampaignsId
            __typename
          }
          nextToken
          __typename
        }
        trackingTags {
          items {
            id
            archived
            trackingTagType
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            errorNotifiedAt
            organizationId
            teamId
            brandId
            dspIds
            status
            ttdId
            name
            pixelCode
            pixelAudienceSize
            pixelUrl
            remainingDays
            piiType
            region
            retainPii
            brandTrackingTagsId
            __typename
          }
          nextToken
          __typename
        }
        isValid
        error
        defaultStripeId
        underReview
        teamBrandsId
        __typename
      }
      inviteCode
      __typename
    }
  }
`;
export const createOrganization = /* GraphQL */ `
  mutation CreateOrganization(
    $input: CreateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    createOrganization(input: $input, condition: $condition) {
      id
      archived
      adminGroups
      viewerGroups
      memberGroups
      createdAt
      updatedAt
      name
      logoUrl
      accountDomain
      accountSubdomain
      accountInfo {
        owner
        ownerEmail
        website
        companyRole
        companyLocation
        companySize
        referencedBy
        industryCategoryId
        sfAccountId
        sfContactId
        sfOwnerId
        ownerPhoneNumber
        __typename
      }
      theme {
        primary
        secondary
        pallet
        __typename
      }
      accountConfig
      config
      accountSettings {
        accountType
        accountTier
        onboardingStatus
        teamId
        brandId
        role
        companySize
        address {
          street
          unitNumber
          city
          state
          postalCode
          country
          __typename
        }
        __typename
      }
      availableCredits
      paymentMethods {
        items {
          stripeId
          nickname
          lastFour
          cardType
          default
          __typename
        }
        __typename
      }
      oMar
      markups {
        oMar
        tMar
        bMar
        __typename
      }
      defaultTeamMarkup
      summaryMetrics {
        items {
          summaryType
          impressions
          clicks
          views
          spend
          conversions
          graphs {
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          __typename
        }
        total
        __typename
      }
      segmentPackages
      teams {
        items {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          name
          websiteUrl
          logoUrl
          industryCategoryId
          config
          availableCredits
          paymentMethods {
            __typename
          }
          tMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultBrandMarkup
          theme {
            primary
            secondary
            pallet
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          brands {
            nextToken
            __typename
          }
          defaultStripeId
          organizationTeamsId
          __typename
        }
        nextToken
        __typename
      }
      whitelabelConfig {
        disableBrandCreditSelfService
        __typename
      }
      overrides {
        minimumCampaignBudget
        __typename
      }
      __typename
    }
  }
`;
export const updateOrganization = /* GraphQL */ `
  mutation UpdateOrganization(
    $input: UpdateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    updateOrganization(input: $input, condition: $condition) {
      id
      archived
      adminGroups
      viewerGroups
      memberGroups
      createdAt
      updatedAt
      name
      logoUrl
      accountDomain
      accountSubdomain
      accountInfo {
        owner
        ownerEmail
        website
        companyRole
        companyLocation
        companySize
        referencedBy
        industryCategoryId
        sfAccountId
        sfContactId
        sfOwnerId
        ownerPhoneNumber
        __typename
      }
      theme {
        primary
        secondary
        pallet
        __typename
      }
      accountConfig
      config
      accountSettings {
        accountType
        accountTier
        onboardingStatus
        teamId
        brandId
        role
        companySize
        address {
          street
          unitNumber
          city
          state
          postalCode
          country
          __typename
        }
        __typename
      }
      availableCredits
      paymentMethods {
        items {
          stripeId
          nickname
          lastFour
          cardType
          default
          __typename
        }
        __typename
      }
      oMar
      markups {
        oMar
        tMar
        bMar
        __typename
      }
      defaultTeamMarkup
      summaryMetrics {
        items {
          summaryType
          impressions
          clicks
          views
          spend
          conversions
          graphs {
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          __typename
        }
        total
        __typename
      }
      segmentPackages
      teams {
        items {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          name
          websiteUrl
          logoUrl
          industryCategoryId
          config
          availableCredits
          paymentMethods {
            __typename
          }
          tMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultBrandMarkup
          theme {
            primary
            secondary
            pallet
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          brands {
            nextToken
            __typename
          }
          defaultStripeId
          organizationTeamsId
          __typename
        }
        nextToken
        __typename
      }
      whitelabelConfig {
        disableBrandCreditSelfService
        __typename
      }
      overrides {
        minimumCampaignBudget
        __typename
      }
      __typename
    }
  }
`;
export const deleteOrganization = /* GraphQL */ `
  mutation DeleteOrganization(
    $input: DeleteOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    deleteOrganization(input: $input, condition: $condition) {
      id
      archived
      adminGroups
      viewerGroups
      memberGroups
      createdAt
      updatedAt
      name
      logoUrl
      accountDomain
      accountSubdomain
      accountInfo {
        owner
        ownerEmail
        website
        companyRole
        companyLocation
        companySize
        referencedBy
        industryCategoryId
        sfAccountId
        sfContactId
        sfOwnerId
        ownerPhoneNumber
        __typename
      }
      theme {
        primary
        secondary
        pallet
        __typename
      }
      accountConfig
      config
      accountSettings {
        accountType
        accountTier
        onboardingStatus
        teamId
        brandId
        role
        companySize
        address {
          street
          unitNumber
          city
          state
          postalCode
          country
          __typename
        }
        __typename
      }
      availableCredits
      paymentMethods {
        items {
          stripeId
          nickname
          lastFour
          cardType
          default
          __typename
        }
        __typename
      }
      oMar
      markups {
        oMar
        tMar
        bMar
        __typename
      }
      defaultTeamMarkup
      summaryMetrics {
        items {
          summaryType
          impressions
          clicks
          views
          spend
          conversions
          graphs {
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          __typename
        }
        total
        __typename
      }
      segmentPackages
      teams {
        items {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          name
          websiteUrl
          logoUrl
          industryCategoryId
          config
          availableCredits
          paymentMethods {
            __typename
          }
          tMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultBrandMarkup
          theme {
            primary
            secondary
            pallet
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          brands {
            nextToken
            __typename
          }
          defaultStripeId
          organizationTeamsId
          __typename
        }
        nextToken
        __typename
      }
      whitelabelConfig {
        disableBrandCreditSelfService
        __typename
      }
      overrides {
        minimumCampaignBudget
        __typename
      }
      __typename
    }
  }
`;
export const createTeam = /* GraphQL */ `
  mutation CreateTeam(
    $input: CreateTeamInput!
    $condition: ModelTeamConditionInput
  ) {
    createTeam(input: $input, condition: $condition) {
      id
      archived
      adminGroups
      viewerGroups
      memberGroups
      createdAt
      updatedAt
      organizationId
      organization {
        id
        archived
        adminGroups
        viewerGroups
        memberGroups
        createdAt
        updatedAt
        name
        logoUrl
        accountDomain
        accountSubdomain
        accountInfo {
          owner
          ownerEmail
          website
          companyRole
          companyLocation
          companySize
          referencedBy
          industryCategoryId
          sfAccountId
          sfContactId
          sfOwnerId
          ownerPhoneNumber
          __typename
        }
        theme {
          primary
          secondary
          pallet
          __typename
        }
        accountConfig
        config
        accountSettings {
          accountType
          accountTier
          onboardingStatus
          teamId
          brandId
          role
          companySize
          address {
            street
            unitNumber
            city
            state
            postalCode
            country
            __typename
          }
          __typename
        }
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        oMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        defaultTeamMarkup
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        teams {
          items {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          nextToken
          __typename
        }
        whitelabelConfig {
          disableBrandCreditSelfService
          __typename
        }
        overrides {
          minimumCampaignBudget
          __typename
        }
        __typename
      }
      name
      websiteUrl
      logoUrl
      industryCategoryId
      config
      availableCredits
      paymentMethods {
        items {
          stripeId
          nickname
          lastFour
          cardType
          default
          __typename
        }
        __typename
      }
      tMar
      markups {
        oMar
        tMar
        bMar
        __typename
      }
      defaultBrandMarkup
      theme {
        primary
        secondary
        pallet
        __typename
      }
      summaryMetrics {
        items {
          summaryType
          impressions
          clicks
          views
          spend
          conversions
          graphs {
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          __typename
        }
        total
        __typename
      }
      segmentPackages
      brands {
        items {
          id
          archived
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          organizationId
          teamId
          team {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          advertiserId
          name
          websiteUrl
          logoUrl
          industryCategoryId
          politicalSettings {
            politicalType
            electionType
            status
            __typename
          }
          campaignPostProcessors
          config
          availableCredits
          paymentMethods {
            __typename
          }
          bMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          universalPixel {
            UniversalPixelId
            UniversalPixelName
            AdvertiserId
            __typename
          }
          pixelCode
          pixelTracking
          pixelAudienceSize
          pixelMappingSizes
          theme {
            primary
            secondary
            pallet
            __typename
          }
          campaignSummary {
            running
            stopped
            completed
            __typename
          }
          creativeSummary {
            audio
            display
            video
            __typename
          }
          reportSummary {
            forecast
            summary
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          campaigns {
            nextToken
            __typename
          }
          trackingTags {
            nextToken
            __typename
          }
          isValid
          error
          defaultStripeId
          underReview
          teamBrandsId
          __typename
        }
        nextToken
        __typename
      }
      defaultStripeId
      organizationTeamsId
      __typename
    }
  }
`;
export const updateTeam = /* GraphQL */ `
  mutation UpdateTeam(
    $input: UpdateTeamInput!
    $condition: ModelTeamConditionInput
  ) {
    updateTeam(input: $input, condition: $condition) {
      id
      archived
      adminGroups
      viewerGroups
      memberGroups
      createdAt
      updatedAt
      organizationId
      organization {
        id
        archived
        adminGroups
        viewerGroups
        memberGroups
        createdAt
        updatedAt
        name
        logoUrl
        accountDomain
        accountSubdomain
        accountInfo {
          owner
          ownerEmail
          website
          companyRole
          companyLocation
          companySize
          referencedBy
          industryCategoryId
          sfAccountId
          sfContactId
          sfOwnerId
          ownerPhoneNumber
          __typename
        }
        theme {
          primary
          secondary
          pallet
          __typename
        }
        accountConfig
        config
        accountSettings {
          accountType
          accountTier
          onboardingStatus
          teamId
          brandId
          role
          companySize
          address {
            street
            unitNumber
            city
            state
            postalCode
            country
            __typename
          }
          __typename
        }
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        oMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        defaultTeamMarkup
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        teams {
          items {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          nextToken
          __typename
        }
        whitelabelConfig {
          disableBrandCreditSelfService
          __typename
        }
        overrides {
          minimumCampaignBudget
          __typename
        }
        __typename
      }
      name
      websiteUrl
      logoUrl
      industryCategoryId
      config
      availableCredits
      paymentMethods {
        items {
          stripeId
          nickname
          lastFour
          cardType
          default
          __typename
        }
        __typename
      }
      tMar
      markups {
        oMar
        tMar
        bMar
        __typename
      }
      defaultBrandMarkup
      theme {
        primary
        secondary
        pallet
        __typename
      }
      summaryMetrics {
        items {
          summaryType
          impressions
          clicks
          views
          spend
          conversions
          graphs {
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          __typename
        }
        total
        __typename
      }
      segmentPackages
      brands {
        items {
          id
          archived
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          organizationId
          teamId
          team {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          advertiserId
          name
          websiteUrl
          logoUrl
          industryCategoryId
          politicalSettings {
            politicalType
            electionType
            status
            __typename
          }
          campaignPostProcessors
          config
          availableCredits
          paymentMethods {
            __typename
          }
          bMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          universalPixel {
            UniversalPixelId
            UniversalPixelName
            AdvertiserId
            __typename
          }
          pixelCode
          pixelTracking
          pixelAudienceSize
          pixelMappingSizes
          theme {
            primary
            secondary
            pallet
            __typename
          }
          campaignSummary {
            running
            stopped
            completed
            __typename
          }
          creativeSummary {
            audio
            display
            video
            __typename
          }
          reportSummary {
            forecast
            summary
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          campaigns {
            nextToken
            __typename
          }
          trackingTags {
            nextToken
            __typename
          }
          isValid
          error
          defaultStripeId
          underReview
          teamBrandsId
          __typename
        }
        nextToken
        __typename
      }
      defaultStripeId
      organizationTeamsId
      __typename
    }
  }
`;
export const deleteTeam = /* GraphQL */ `
  mutation DeleteTeam(
    $input: DeleteTeamInput!
    $condition: ModelTeamConditionInput
  ) {
    deleteTeam(input: $input, condition: $condition) {
      id
      archived
      adminGroups
      viewerGroups
      memberGroups
      createdAt
      updatedAt
      organizationId
      organization {
        id
        archived
        adminGroups
        viewerGroups
        memberGroups
        createdAt
        updatedAt
        name
        logoUrl
        accountDomain
        accountSubdomain
        accountInfo {
          owner
          ownerEmail
          website
          companyRole
          companyLocation
          companySize
          referencedBy
          industryCategoryId
          sfAccountId
          sfContactId
          sfOwnerId
          ownerPhoneNumber
          __typename
        }
        theme {
          primary
          secondary
          pallet
          __typename
        }
        accountConfig
        config
        accountSettings {
          accountType
          accountTier
          onboardingStatus
          teamId
          brandId
          role
          companySize
          address {
            street
            unitNumber
            city
            state
            postalCode
            country
            __typename
          }
          __typename
        }
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        oMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        defaultTeamMarkup
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        teams {
          items {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          nextToken
          __typename
        }
        whitelabelConfig {
          disableBrandCreditSelfService
          __typename
        }
        overrides {
          minimumCampaignBudget
          __typename
        }
        __typename
      }
      name
      websiteUrl
      logoUrl
      industryCategoryId
      config
      availableCredits
      paymentMethods {
        items {
          stripeId
          nickname
          lastFour
          cardType
          default
          __typename
        }
        __typename
      }
      tMar
      markups {
        oMar
        tMar
        bMar
        __typename
      }
      defaultBrandMarkup
      theme {
        primary
        secondary
        pallet
        __typename
      }
      summaryMetrics {
        items {
          summaryType
          impressions
          clicks
          views
          spend
          conversions
          graphs {
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          __typename
        }
        total
        __typename
      }
      segmentPackages
      brands {
        items {
          id
          archived
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          organizationId
          teamId
          team {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          advertiserId
          name
          websiteUrl
          logoUrl
          industryCategoryId
          politicalSettings {
            politicalType
            electionType
            status
            __typename
          }
          campaignPostProcessors
          config
          availableCredits
          paymentMethods {
            __typename
          }
          bMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          universalPixel {
            UniversalPixelId
            UniversalPixelName
            AdvertiserId
            __typename
          }
          pixelCode
          pixelTracking
          pixelAudienceSize
          pixelMappingSizes
          theme {
            primary
            secondary
            pallet
            __typename
          }
          campaignSummary {
            running
            stopped
            completed
            __typename
          }
          creativeSummary {
            audio
            display
            video
            __typename
          }
          reportSummary {
            forecast
            summary
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          campaigns {
            nextToken
            __typename
          }
          trackingTags {
            nextToken
            __typename
          }
          isValid
          error
          defaultStripeId
          underReview
          teamBrandsId
          __typename
        }
        nextToken
        __typename
      }
      defaultStripeId
      organizationTeamsId
      __typename
    }
  }
`;
export const createBrand = /* GraphQL */ `
  mutation CreateBrand(
    $input: CreateBrandInput!
    $condition: ModelBrandConditionInput
  ) {
    createBrand(input: $input, condition: $condition) {
      id
      archived
      adminGroups
      viewerGroups
      createdAt
      updatedAt
      organizationId
      teamId
      team {
        id
        archived
        adminGroups
        viewerGroups
        memberGroups
        createdAt
        updatedAt
        organizationId
        organization {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          name
          logoUrl
          accountDomain
          accountSubdomain
          accountInfo {
            owner
            ownerEmail
            website
            companyRole
            companyLocation
            companySize
            referencedBy
            industryCategoryId
            sfAccountId
            sfContactId
            sfOwnerId
            ownerPhoneNumber
            __typename
          }
          theme {
            primary
            secondary
            pallet
            __typename
          }
          accountConfig
          config
          accountSettings {
            accountType
            accountTier
            onboardingStatus
            teamId
            brandId
            role
            companySize
            __typename
          }
          availableCredits
          paymentMethods {
            __typename
          }
          oMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultTeamMarkup
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          teams {
            nextToken
            __typename
          }
          whitelabelConfig {
            disableBrandCreditSelfService
            __typename
          }
          overrides {
            minimumCampaignBudget
            __typename
          }
          __typename
        }
        name
        websiteUrl
        logoUrl
        industryCategoryId
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        tMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        defaultBrandMarkup
        theme {
          primary
          secondary
          pallet
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        brands {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          nextToken
          __typename
        }
        defaultStripeId
        organizationTeamsId
        __typename
      }
      advertiserId
      name
      websiteUrl
      logoUrl
      industryCategoryId
      politicalSettings {
        politicalType
        electionType
        candidate {
          PoliticalDataId
          CandidateName
          ElectionState
          PayingEntityName
          PayingEntityAddress
          PayingEntityEmailAddress
          PayingEntityExecutiveName
          PayingEntityExecutiveTitle
          GeoDescription
          AudienceDescription
          DisclaimerNotice
          FileLocationInS3
          FederalVerificationId
          StateVerificationId
          IsAdvertiserIEC
          __typename
        }
        status
        ballotMeasureProfile {
          PayingEntityName
          PayingEntityAddress
          PayingEntityExecutiveName
          PayingEntityExecutiveTitle
          ElectionState
          __typename
        }
        __typename
      }
      campaignPostProcessors
      config
      availableCredits
      paymentMethods {
        items {
          stripeId
          nickname
          lastFour
          cardType
          default
          __typename
        }
        __typename
      }
      bMar
      markups {
        oMar
        tMar
        bMar
        __typename
      }
      universalPixel {
        UniversalPixelMappings {
          ExactMatchMappings {
            Url
            HouseholdExtensionEnabled
            Revenue
            Currency
            TrackingTagId
            UniversalPixelMappingName
            UniversalPixelMappingType
            Description
            HitCount30Day
            FirstPartyDataId
            __typename
          }
          WildcardMatchMappings {
            UrlPattern
            HouseholdExtensionEnabled
            Revenue
            Currency
            TrackingTagId
            UniversalPixelMappingName
            UniversalPixelMappingType
            Description
            HitCount30Day
            FirstPartyDataId
            __typename
          }
          __typename
        }
        UniversalPixelId
        UniversalPixelName
        AdvertiserId
        __typename
      }
      pixelCode
      pixelTracking
      pixelAudienceSize
      pixelMappingSizes
      theme {
        primary
        secondary
        pallet
        __typename
      }
      campaignSummary {
        running
        stopped
        completed
        __typename
      }
      creativeSummary {
        audio
        display
        video
        __typename
      }
      reportSummary {
        forecast
        summary
        __typename
      }
      summaryMetrics {
        items {
          summaryType
          impressions
          clicks
          views
          spend
          conversions
          graphs {
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          __typename
        }
        total
        __typename
      }
      segmentPackages
      campaigns {
        items {
          id
          archived
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          stoppedAt
          approvedAt
          lastRecurredAt
          organizationId
          teamId
          brandId
          brand {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          status
          recurrenceWindow
          recurrenceBudget
          name
          goal
          budget
          originalBudget
          dailyBudget
          startDate
          endDate
          originalEndDate
          audienceType
          audienceFrom
          retargetingTags {
            dspId
            firstPartyDataId
            trackingTagId
            __typename
          }
          geoSegments {
            id
            segmentPackageId
            dspId
            name
            pathKey
            segmentType
            segmentGroup
            __typename
          }
          dmpSegments {
            id
            segmentPackageId
            dspId
            name
            pathKey
            segmentType
            segmentGroup
            __typename
          }
          inventorySegments {
            id
            segmentPackageId
            dspId
            name
            pathKey
            segmentType
            segmentGroup
            __typename
          }
          timesOfDay
          daysOfWeek
          creatives {
            nextToken
            __typename
          }
          forecastRequestedAt
          forecastAdgroups
          publishedAt
          forecast {
            requestedAt
            createdAt
            __typename
          }
          ttdId
          conversionsEnabled
          trackingTagId
          pixelTrackingUrl
          conversionEvents {
            type
            id
            __typename
          }
          ttdStatus
          dspIds
          audience
          bidlists
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          ttdUpdatedAt
          activeUpdatedAt
          sfOpportunityId
          ctvSegments
          isRecurring
          isValid
          error
          isMultiDataGroups
          campaignPoliticalSettings {
            type
            __typename
          }
          additionalBidLists
          postProcessors
          brandCampaignsId
          __typename
        }
        nextToken
        __typename
      }
      trackingTags {
        items {
          id
          archived
          trackingTagType
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          errorNotifiedAt
          organizationId
          teamId
          brandId
          dspIds
          status
          ttdId
          name
          pixelCode
          pixelAudienceSize
          pixelUrl
          remainingDays
          brand {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          piiType
          region
          retainPii
          brandTrackingTagsId
          __typename
        }
        nextToken
        __typename
      }
      isValid
      error
      defaultStripeId
      underReview
      teamBrandsId
      __typename
    }
  }
`;
export const updateBrand = /* GraphQL */ `
  mutation UpdateBrand(
    $input: UpdateBrandInput!
    $condition: ModelBrandConditionInput
  ) {
    updateBrand(input: $input, condition: $condition) {
      id
      archived
      adminGroups
      viewerGroups
      createdAt
      updatedAt
      organizationId
      teamId
      team {
        id
        archived
        adminGroups
        viewerGroups
        memberGroups
        createdAt
        updatedAt
        organizationId
        organization {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          name
          logoUrl
          accountDomain
          accountSubdomain
          accountInfo {
            owner
            ownerEmail
            website
            companyRole
            companyLocation
            companySize
            referencedBy
            industryCategoryId
            sfAccountId
            sfContactId
            sfOwnerId
            ownerPhoneNumber
            __typename
          }
          theme {
            primary
            secondary
            pallet
            __typename
          }
          accountConfig
          config
          accountSettings {
            accountType
            accountTier
            onboardingStatus
            teamId
            brandId
            role
            companySize
            __typename
          }
          availableCredits
          paymentMethods {
            __typename
          }
          oMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultTeamMarkup
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          teams {
            nextToken
            __typename
          }
          whitelabelConfig {
            disableBrandCreditSelfService
            __typename
          }
          overrides {
            minimumCampaignBudget
            __typename
          }
          __typename
        }
        name
        websiteUrl
        logoUrl
        industryCategoryId
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        tMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        defaultBrandMarkup
        theme {
          primary
          secondary
          pallet
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        brands {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          nextToken
          __typename
        }
        defaultStripeId
        organizationTeamsId
        __typename
      }
      advertiserId
      name
      websiteUrl
      logoUrl
      industryCategoryId
      politicalSettings {
        politicalType
        electionType
        candidate {
          PoliticalDataId
          CandidateName
          ElectionState
          PayingEntityName
          PayingEntityAddress
          PayingEntityEmailAddress
          PayingEntityExecutiveName
          PayingEntityExecutiveTitle
          GeoDescription
          AudienceDescription
          DisclaimerNotice
          FileLocationInS3
          FederalVerificationId
          StateVerificationId
          IsAdvertiserIEC
          __typename
        }
        status
        ballotMeasureProfile {
          PayingEntityName
          PayingEntityAddress
          PayingEntityExecutiveName
          PayingEntityExecutiveTitle
          ElectionState
          __typename
        }
        __typename
      }
      campaignPostProcessors
      config
      availableCredits
      paymentMethods {
        items {
          stripeId
          nickname
          lastFour
          cardType
          default
          __typename
        }
        __typename
      }
      bMar
      markups {
        oMar
        tMar
        bMar
        __typename
      }
      universalPixel {
        UniversalPixelMappings {
          ExactMatchMappings {
            Url
            HouseholdExtensionEnabled
            Revenue
            Currency
            TrackingTagId
            UniversalPixelMappingName
            UniversalPixelMappingType
            Description
            HitCount30Day
            FirstPartyDataId
            __typename
          }
          WildcardMatchMappings {
            UrlPattern
            HouseholdExtensionEnabled
            Revenue
            Currency
            TrackingTagId
            UniversalPixelMappingName
            UniversalPixelMappingType
            Description
            HitCount30Day
            FirstPartyDataId
            __typename
          }
          __typename
        }
        UniversalPixelId
        UniversalPixelName
        AdvertiserId
        __typename
      }
      pixelCode
      pixelTracking
      pixelAudienceSize
      pixelMappingSizes
      theme {
        primary
        secondary
        pallet
        __typename
      }
      campaignSummary {
        running
        stopped
        completed
        __typename
      }
      creativeSummary {
        audio
        display
        video
        __typename
      }
      reportSummary {
        forecast
        summary
        __typename
      }
      summaryMetrics {
        items {
          summaryType
          impressions
          clicks
          views
          spend
          conversions
          graphs {
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          __typename
        }
        total
        __typename
      }
      segmentPackages
      campaigns {
        items {
          id
          archived
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          stoppedAt
          approvedAt
          lastRecurredAt
          organizationId
          teamId
          brandId
          brand {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          status
          recurrenceWindow
          recurrenceBudget
          name
          goal
          budget
          originalBudget
          dailyBudget
          startDate
          endDate
          originalEndDate
          audienceType
          audienceFrom
          retargetingTags {
            dspId
            firstPartyDataId
            trackingTagId
            __typename
          }
          geoSegments {
            id
            segmentPackageId
            dspId
            name
            pathKey
            segmentType
            segmentGroup
            __typename
          }
          dmpSegments {
            id
            segmentPackageId
            dspId
            name
            pathKey
            segmentType
            segmentGroup
            __typename
          }
          inventorySegments {
            id
            segmentPackageId
            dspId
            name
            pathKey
            segmentType
            segmentGroup
            __typename
          }
          timesOfDay
          daysOfWeek
          creatives {
            nextToken
            __typename
          }
          forecastRequestedAt
          forecastAdgroups
          publishedAt
          forecast {
            requestedAt
            createdAt
            __typename
          }
          ttdId
          conversionsEnabled
          trackingTagId
          pixelTrackingUrl
          conversionEvents {
            type
            id
            __typename
          }
          ttdStatus
          dspIds
          audience
          bidlists
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          ttdUpdatedAt
          activeUpdatedAt
          sfOpportunityId
          ctvSegments
          isRecurring
          isValid
          error
          isMultiDataGroups
          campaignPoliticalSettings {
            type
            __typename
          }
          additionalBidLists
          postProcessors
          brandCampaignsId
          __typename
        }
        nextToken
        __typename
      }
      trackingTags {
        items {
          id
          archived
          trackingTagType
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          errorNotifiedAt
          organizationId
          teamId
          brandId
          dspIds
          status
          ttdId
          name
          pixelCode
          pixelAudienceSize
          pixelUrl
          remainingDays
          brand {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          piiType
          region
          retainPii
          brandTrackingTagsId
          __typename
        }
        nextToken
        __typename
      }
      isValid
      error
      defaultStripeId
      underReview
      teamBrandsId
      __typename
    }
  }
`;
export const deleteBrand = /* GraphQL */ `
  mutation DeleteBrand(
    $input: DeleteBrandInput!
    $condition: ModelBrandConditionInput
  ) {
    deleteBrand(input: $input, condition: $condition) {
      id
      archived
      adminGroups
      viewerGroups
      createdAt
      updatedAt
      organizationId
      teamId
      team {
        id
        archived
        adminGroups
        viewerGroups
        memberGroups
        createdAt
        updatedAt
        organizationId
        organization {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          name
          logoUrl
          accountDomain
          accountSubdomain
          accountInfo {
            owner
            ownerEmail
            website
            companyRole
            companyLocation
            companySize
            referencedBy
            industryCategoryId
            sfAccountId
            sfContactId
            sfOwnerId
            ownerPhoneNumber
            __typename
          }
          theme {
            primary
            secondary
            pallet
            __typename
          }
          accountConfig
          config
          accountSettings {
            accountType
            accountTier
            onboardingStatus
            teamId
            brandId
            role
            companySize
            __typename
          }
          availableCredits
          paymentMethods {
            __typename
          }
          oMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultTeamMarkup
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          teams {
            nextToken
            __typename
          }
          whitelabelConfig {
            disableBrandCreditSelfService
            __typename
          }
          overrides {
            minimumCampaignBudget
            __typename
          }
          __typename
        }
        name
        websiteUrl
        logoUrl
        industryCategoryId
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        tMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        defaultBrandMarkup
        theme {
          primary
          secondary
          pallet
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        brands {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          nextToken
          __typename
        }
        defaultStripeId
        organizationTeamsId
        __typename
      }
      advertiserId
      name
      websiteUrl
      logoUrl
      industryCategoryId
      politicalSettings {
        politicalType
        electionType
        candidate {
          PoliticalDataId
          CandidateName
          ElectionState
          PayingEntityName
          PayingEntityAddress
          PayingEntityEmailAddress
          PayingEntityExecutiveName
          PayingEntityExecutiveTitle
          GeoDescription
          AudienceDescription
          DisclaimerNotice
          FileLocationInS3
          FederalVerificationId
          StateVerificationId
          IsAdvertiserIEC
          __typename
        }
        status
        ballotMeasureProfile {
          PayingEntityName
          PayingEntityAddress
          PayingEntityExecutiveName
          PayingEntityExecutiveTitle
          ElectionState
          __typename
        }
        __typename
      }
      campaignPostProcessors
      config
      availableCredits
      paymentMethods {
        items {
          stripeId
          nickname
          lastFour
          cardType
          default
          __typename
        }
        __typename
      }
      bMar
      markups {
        oMar
        tMar
        bMar
        __typename
      }
      universalPixel {
        UniversalPixelMappings {
          ExactMatchMappings {
            Url
            HouseholdExtensionEnabled
            Revenue
            Currency
            TrackingTagId
            UniversalPixelMappingName
            UniversalPixelMappingType
            Description
            HitCount30Day
            FirstPartyDataId
            __typename
          }
          WildcardMatchMappings {
            UrlPattern
            HouseholdExtensionEnabled
            Revenue
            Currency
            TrackingTagId
            UniversalPixelMappingName
            UniversalPixelMappingType
            Description
            HitCount30Day
            FirstPartyDataId
            __typename
          }
          __typename
        }
        UniversalPixelId
        UniversalPixelName
        AdvertiserId
        __typename
      }
      pixelCode
      pixelTracking
      pixelAudienceSize
      pixelMappingSizes
      theme {
        primary
        secondary
        pallet
        __typename
      }
      campaignSummary {
        running
        stopped
        completed
        __typename
      }
      creativeSummary {
        audio
        display
        video
        __typename
      }
      reportSummary {
        forecast
        summary
        __typename
      }
      summaryMetrics {
        items {
          summaryType
          impressions
          clicks
          views
          spend
          conversions
          graphs {
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          __typename
        }
        total
        __typename
      }
      segmentPackages
      campaigns {
        items {
          id
          archived
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          stoppedAt
          approvedAt
          lastRecurredAt
          organizationId
          teamId
          brandId
          brand {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          status
          recurrenceWindow
          recurrenceBudget
          name
          goal
          budget
          originalBudget
          dailyBudget
          startDate
          endDate
          originalEndDate
          audienceType
          audienceFrom
          retargetingTags {
            dspId
            firstPartyDataId
            trackingTagId
            __typename
          }
          geoSegments {
            id
            segmentPackageId
            dspId
            name
            pathKey
            segmentType
            segmentGroup
            __typename
          }
          dmpSegments {
            id
            segmentPackageId
            dspId
            name
            pathKey
            segmentType
            segmentGroup
            __typename
          }
          inventorySegments {
            id
            segmentPackageId
            dspId
            name
            pathKey
            segmentType
            segmentGroup
            __typename
          }
          timesOfDay
          daysOfWeek
          creatives {
            nextToken
            __typename
          }
          forecastRequestedAt
          forecastAdgroups
          publishedAt
          forecast {
            requestedAt
            createdAt
            __typename
          }
          ttdId
          conversionsEnabled
          trackingTagId
          pixelTrackingUrl
          conversionEvents {
            type
            id
            __typename
          }
          ttdStatus
          dspIds
          audience
          bidlists
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          ttdUpdatedAt
          activeUpdatedAt
          sfOpportunityId
          ctvSegments
          isRecurring
          isValid
          error
          isMultiDataGroups
          campaignPoliticalSettings {
            type
            __typename
          }
          additionalBidLists
          postProcessors
          brandCampaignsId
          __typename
        }
        nextToken
        __typename
      }
      trackingTags {
        items {
          id
          archived
          trackingTagType
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          errorNotifiedAt
          organizationId
          teamId
          brandId
          dspIds
          status
          ttdId
          name
          pixelCode
          pixelAudienceSize
          pixelUrl
          remainingDays
          brand {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            organizationId
            teamId
            advertiserId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            campaignPostProcessors
            config
            availableCredits
            bMar
            pixelCode
            pixelTracking
            pixelAudienceSize
            pixelMappingSizes
            segmentPackages
            isValid
            error
            defaultStripeId
            underReview
            teamBrandsId
            __typename
          }
          piiType
          region
          retainPii
          brandTrackingTagsId
          __typename
        }
        nextToken
        __typename
      }
      isValid
      error
      defaultStripeId
      underReview
      teamBrandsId
      __typename
    }
  }
`;
export const createCampaign = /* GraphQL */ `
  mutation CreateCampaign(
    $input: CreateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    createCampaign(input: $input, condition: $condition) {
      id
      archived
      adminGroups
      viewerGroups
      createdAt
      updatedAt
      stoppedAt
      approvedAt
      lastRecurredAt
      organizationId
      teamId
      brandId
      brand {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        organizationId
        teamId
        team {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          name
          websiteUrl
          logoUrl
          industryCategoryId
          config
          availableCredits
          paymentMethods {
            __typename
          }
          tMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultBrandMarkup
          theme {
            primary
            secondary
            pallet
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          brands {
            nextToken
            __typename
          }
          defaultStripeId
          organizationTeamsId
          __typename
        }
        advertiserId
        name
        websiteUrl
        logoUrl
        industryCategoryId
        politicalSettings {
          politicalType
          electionType
          candidate {
            PoliticalDataId
            CandidateName
            ElectionState
            PayingEntityName
            PayingEntityAddress
            PayingEntityEmailAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            GeoDescription
            AudienceDescription
            DisclaimerNotice
            FileLocationInS3
            FederalVerificationId
            StateVerificationId
            IsAdvertiserIEC
            __typename
          }
          status
          ballotMeasureProfile {
            PayingEntityName
            PayingEntityAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            ElectionState
            __typename
          }
          __typename
        }
        campaignPostProcessors
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        bMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        universalPixel {
          UniversalPixelMappings {
            __typename
          }
          UniversalPixelId
          UniversalPixelName
          AdvertiserId
          __typename
        }
        pixelCode
        pixelTracking
        pixelAudienceSize
        pixelMappingSizes
        theme {
          primary
          secondary
          pallet
          __typename
        }
        campaignSummary {
          running
          stopped
          completed
          __typename
        }
        creativeSummary {
          audio
          display
          video
          __typename
        }
        reportSummary {
          forecast
          summary
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        campaigns {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            stoppedAt
            approvedAt
            lastRecurredAt
            organizationId
            teamId
            brandId
            status
            recurrenceWindow
            recurrenceBudget
            name
            goal
            budget
            originalBudget
            dailyBudget
            startDate
            endDate
            originalEndDate
            audienceType
            audienceFrom
            timesOfDay
            daysOfWeek
            forecastRequestedAt
            forecastAdgroups
            publishedAt
            ttdId
            conversionsEnabled
            trackingTagId
            pixelTrackingUrl
            ttdStatus
            dspIds
            audience
            bidlists
            ttdUpdatedAt
            activeUpdatedAt
            sfOpportunityId
            ctvSegments
            isRecurring
            isValid
            error
            isMultiDataGroups
            additionalBidLists
            postProcessors
            brandCampaignsId
            __typename
          }
          nextToken
          __typename
        }
        trackingTags {
          items {
            id
            archived
            trackingTagType
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            errorNotifiedAt
            organizationId
            teamId
            brandId
            dspIds
            status
            ttdId
            name
            pixelCode
            pixelAudienceSize
            pixelUrl
            remainingDays
            piiType
            region
            retainPii
            brandTrackingTagsId
            __typename
          }
          nextToken
          __typename
        }
        isValid
        error
        defaultStripeId
        underReview
        teamBrandsId
        __typename
      }
      status
      recurrenceWindow
      recurrenceBudget
      name
      goal
      budget
      originalBudget
      dailyBudget
      startDate
      endDate
      originalEndDate
      audienceType
      audienceFrom
      retargetingTags {
        dspId
        firstPartyDataId
        trackingTagId
        __typename
      }
      geoSegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      dmpSegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      inventorySegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      timesOfDay
      daysOfWeek
      creatives {
        items {
          id
          archived
          createdAt
          updatedAt
          uploadedAt
          publishedAt
          adminGroups
          viewerGroups
          organizationId
          teamBrandCampaign
          teamId
          brandId
          campaignId
          campaign {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            stoppedAt
            approvedAt
            lastRecurredAt
            organizationId
            teamId
            brandId
            status
            recurrenceWindow
            recurrenceBudget
            name
            goal
            budget
            originalBudget
            dailyBudget
            startDate
            endDate
            originalEndDate
            audienceType
            audienceFrom
            timesOfDay
            daysOfWeek
            forecastRequestedAt
            forecastAdgroups
            publishedAt
            ttdId
            conversionsEnabled
            trackingTagId
            pixelTrackingUrl
            ttdStatus
            dspIds
            audience
            bidlists
            ttdUpdatedAt
            activeUpdatedAt
            sfOpportunityId
            ctvSegments
            isRecurring
            isValid
            error
            isMultiDataGroups
            additionalBidLists
            postProcessors
            brandCampaignsId
            __typename
          }
          teamBrandCampaignId
          name
          fileName
          creativeType
          s3Key
          s3ThumbnailKey
          clickthroughUrl
          landingPageUrl
          inApp
          web
          ctv
          displayTargeting
          devices
          dspIds
          ttdId
          ttdStatus
          isValid
          error
          campaignCreativesId
          __typename
        }
        nextToken
        __typename
      }
      forecastRequestedAt
      forecastAdgroups
      publishedAt
      forecast {
        requestedAt
        createdAt
        impressions {
          max
          min
          __typename
        }
        reach {
          max
          min
          __typename
        }
        frequency {
          max
          min
          __typename
        }
        spend {
          max
          min
          __typename
        }
        results {
          adgroupType
          impressions {
            max
            min
            __typename
          }
          reach {
            max
            min
            __typename
          }
          frequency {
            max
            min
            __typename
          }
          spend {
            max
            min
            __typename
          }
          __typename
        }
        __typename
      }
      ttdId
      conversionsEnabled
      trackingTagId
      pixelTrackingUrl
      conversionEvents {
        type
        id
        __typename
      }
      ttdStatus
      dspIds
      audience
      bidlists
      markups {
        oMar
        tMar
        bMar
        __typename
      }
      summaryMetrics {
        items {
          summaryType
          impressions
          clicks
          views
          spend
          conversions
          graphs {
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          __typename
        }
        total
        __typename
      }
      ttdUpdatedAt
      activeUpdatedAt
      sfOpportunityId
      ctvSegments
      isRecurring
      isValid
      error
      isMultiDataGroups
      campaignPoliticalSettings {
        type
        __typename
      }
      additionalBidLists
      postProcessors
      brandCampaignsId
      __typename
    }
  }
`;
export const updateCampaign = /* GraphQL */ `
  mutation UpdateCampaign(
    $input: UpdateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    updateCampaign(input: $input, condition: $condition) {
      id
      archived
      adminGroups
      viewerGroups
      createdAt
      updatedAt
      stoppedAt
      approvedAt
      lastRecurredAt
      organizationId
      teamId
      brandId
      brand {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        organizationId
        teamId
        team {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          name
          websiteUrl
          logoUrl
          industryCategoryId
          config
          availableCredits
          paymentMethods {
            __typename
          }
          tMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultBrandMarkup
          theme {
            primary
            secondary
            pallet
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          brands {
            nextToken
            __typename
          }
          defaultStripeId
          organizationTeamsId
          __typename
        }
        advertiserId
        name
        websiteUrl
        logoUrl
        industryCategoryId
        politicalSettings {
          politicalType
          electionType
          candidate {
            PoliticalDataId
            CandidateName
            ElectionState
            PayingEntityName
            PayingEntityAddress
            PayingEntityEmailAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            GeoDescription
            AudienceDescription
            DisclaimerNotice
            FileLocationInS3
            FederalVerificationId
            StateVerificationId
            IsAdvertiserIEC
            __typename
          }
          status
          ballotMeasureProfile {
            PayingEntityName
            PayingEntityAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            ElectionState
            __typename
          }
          __typename
        }
        campaignPostProcessors
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        bMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        universalPixel {
          UniversalPixelMappings {
            __typename
          }
          UniversalPixelId
          UniversalPixelName
          AdvertiserId
          __typename
        }
        pixelCode
        pixelTracking
        pixelAudienceSize
        pixelMappingSizes
        theme {
          primary
          secondary
          pallet
          __typename
        }
        campaignSummary {
          running
          stopped
          completed
          __typename
        }
        creativeSummary {
          audio
          display
          video
          __typename
        }
        reportSummary {
          forecast
          summary
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        campaigns {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            stoppedAt
            approvedAt
            lastRecurredAt
            organizationId
            teamId
            brandId
            status
            recurrenceWindow
            recurrenceBudget
            name
            goal
            budget
            originalBudget
            dailyBudget
            startDate
            endDate
            originalEndDate
            audienceType
            audienceFrom
            timesOfDay
            daysOfWeek
            forecastRequestedAt
            forecastAdgroups
            publishedAt
            ttdId
            conversionsEnabled
            trackingTagId
            pixelTrackingUrl
            ttdStatus
            dspIds
            audience
            bidlists
            ttdUpdatedAt
            activeUpdatedAt
            sfOpportunityId
            ctvSegments
            isRecurring
            isValid
            error
            isMultiDataGroups
            additionalBidLists
            postProcessors
            brandCampaignsId
            __typename
          }
          nextToken
          __typename
        }
        trackingTags {
          items {
            id
            archived
            trackingTagType
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            errorNotifiedAt
            organizationId
            teamId
            brandId
            dspIds
            status
            ttdId
            name
            pixelCode
            pixelAudienceSize
            pixelUrl
            remainingDays
            piiType
            region
            retainPii
            brandTrackingTagsId
            __typename
          }
          nextToken
          __typename
        }
        isValid
        error
        defaultStripeId
        underReview
        teamBrandsId
        __typename
      }
      status
      recurrenceWindow
      recurrenceBudget
      name
      goal
      budget
      originalBudget
      dailyBudget
      startDate
      endDate
      originalEndDate
      audienceType
      audienceFrom
      retargetingTags {
        dspId
        firstPartyDataId
        trackingTagId
        __typename
      }
      geoSegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      dmpSegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      inventorySegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      timesOfDay
      daysOfWeek
      creatives {
        items {
          id
          archived
          createdAt
          updatedAt
          uploadedAt
          publishedAt
          adminGroups
          viewerGroups
          organizationId
          teamBrandCampaign
          teamId
          brandId
          campaignId
          campaign {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            stoppedAt
            approvedAt
            lastRecurredAt
            organizationId
            teamId
            brandId
            status
            recurrenceWindow
            recurrenceBudget
            name
            goal
            budget
            originalBudget
            dailyBudget
            startDate
            endDate
            originalEndDate
            audienceType
            audienceFrom
            timesOfDay
            daysOfWeek
            forecastRequestedAt
            forecastAdgroups
            publishedAt
            ttdId
            conversionsEnabled
            trackingTagId
            pixelTrackingUrl
            ttdStatus
            dspIds
            audience
            bidlists
            ttdUpdatedAt
            activeUpdatedAt
            sfOpportunityId
            ctvSegments
            isRecurring
            isValid
            error
            isMultiDataGroups
            additionalBidLists
            postProcessors
            brandCampaignsId
            __typename
          }
          teamBrandCampaignId
          name
          fileName
          creativeType
          s3Key
          s3ThumbnailKey
          clickthroughUrl
          landingPageUrl
          inApp
          web
          ctv
          displayTargeting
          devices
          dspIds
          ttdId
          ttdStatus
          isValid
          error
          campaignCreativesId
          __typename
        }
        nextToken
        __typename
      }
      forecastRequestedAt
      forecastAdgroups
      publishedAt
      forecast {
        requestedAt
        createdAt
        impressions {
          max
          min
          __typename
        }
        reach {
          max
          min
          __typename
        }
        frequency {
          max
          min
          __typename
        }
        spend {
          max
          min
          __typename
        }
        results {
          adgroupType
          impressions {
            max
            min
            __typename
          }
          reach {
            max
            min
            __typename
          }
          frequency {
            max
            min
            __typename
          }
          spend {
            max
            min
            __typename
          }
          __typename
        }
        __typename
      }
      ttdId
      conversionsEnabled
      trackingTagId
      pixelTrackingUrl
      conversionEvents {
        type
        id
        __typename
      }
      ttdStatus
      dspIds
      audience
      bidlists
      markups {
        oMar
        tMar
        bMar
        __typename
      }
      summaryMetrics {
        items {
          summaryType
          impressions
          clicks
          views
          spend
          conversions
          graphs {
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          __typename
        }
        total
        __typename
      }
      ttdUpdatedAt
      activeUpdatedAt
      sfOpportunityId
      ctvSegments
      isRecurring
      isValid
      error
      isMultiDataGroups
      campaignPoliticalSettings {
        type
        __typename
      }
      additionalBidLists
      postProcessors
      brandCampaignsId
      __typename
    }
  }
`;
export const deleteCampaign = /* GraphQL */ `
  mutation DeleteCampaign(
    $input: DeleteCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    deleteCampaign(input: $input, condition: $condition) {
      id
      archived
      adminGroups
      viewerGroups
      createdAt
      updatedAt
      stoppedAt
      approvedAt
      lastRecurredAt
      organizationId
      teamId
      brandId
      brand {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        organizationId
        teamId
        team {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          name
          websiteUrl
          logoUrl
          industryCategoryId
          config
          availableCredits
          paymentMethods {
            __typename
          }
          tMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultBrandMarkup
          theme {
            primary
            secondary
            pallet
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          brands {
            nextToken
            __typename
          }
          defaultStripeId
          organizationTeamsId
          __typename
        }
        advertiserId
        name
        websiteUrl
        logoUrl
        industryCategoryId
        politicalSettings {
          politicalType
          electionType
          candidate {
            PoliticalDataId
            CandidateName
            ElectionState
            PayingEntityName
            PayingEntityAddress
            PayingEntityEmailAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            GeoDescription
            AudienceDescription
            DisclaimerNotice
            FileLocationInS3
            FederalVerificationId
            StateVerificationId
            IsAdvertiserIEC
            __typename
          }
          status
          ballotMeasureProfile {
            PayingEntityName
            PayingEntityAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            ElectionState
            __typename
          }
          __typename
        }
        campaignPostProcessors
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        bMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        universalPixel {
          UniversalPixelMappings {
            __typename
          }
          UniversalPixelId
          UniversalPixelName
          AdvertiserId
          __typename
        }
        pixelCode
        pixelTracking
        pixelAudienceSize
        pixelMappingSizes
        theme {
          primary
          secondary
          pallet
          __typename
        }
        campaignSummary {
          running
          stopped
          completed
          __typename
        }
        creativeSummary {
          audio
          display
          video
          __typename
        }
        reportSummary {
          forecast
          summary
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        campaigns {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            stoppedAt
            approvedAt
            lastRecurredAt
            organizationId
            teamId
            brandId
            status
            recurrenceWindow
            recurrenceBudget
            name
            goal
            budget
            originalBudget
            dailyBudget
            startDate
            endDate
            originalEndDate
            audienceType
            audienceFrom
            timesOfDay
            daysOfWeek
            forecastRequestedAt
            forecastAdgroups
            publishedAt
            ttdId
            conversionsEnabled
            trackingTagId
            pixelTrackingUrl
            ttdStatus
            dspIds
            audience
            bidlists
            ttdUpdatedAt
            activeUpdatedAt
            sfOpportunityId
            ctvSegments
            isRecurring
            isValid
            error
            isMultiDataGroups
            additionalBidLists
            postProcessors
            brandCampaignsId
            __typename
          }
          nextToken
          __typename
        }
        trackingTags {
          items {
            id
            archived
            trackingTagType
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            errorNotifiedAt
            organizationId
            teamId
            brandId
            dspIds
            status
            ttdId
            name
            pixelCode
            pixelAudienceSize
            pixelUrl
            remainingDays
            piiType
            region
            retainPii
            brandTrackingTagsId
            __typename
          }
          nextToken
          __typename
        }
        isValid
        error
        defaultStripeId
        underReview
        teamBrandsId
        __typename
      }
      status
      recurrenceWindow
      recurrenceBudget
      name
      goal
      budget
      originalBudget
      dailyBudget
      startDate
      endDate
      originalEndDate
      audienceType
      audienceFrom
      retargetingTags {
        dspId
        firstPartyDataId
        trackingTagId
        __typename
      }
      geoSegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      dmpSegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      inventorySegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      timesOfDay
      daysOfWeek
      creatives {
        items {
          id
          archived
          createdAt
          updatedAt
          uploadedAt
          publishedAt
          adminGroups
          viewerGroups
          organizationId
          teamBrandCampaign
          teamId
          brandId
          campaignId
          campaign {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            stoppedAt
            approvedAt
            lastRecurredAt
            organizationId
            teamId
            brandId
            status
            recurrenceWindow
            recurrenceBudget
            name
            goal
            budget
            originalBudget
            dailyBudget
            startDate
            endDate
            originalEndDate
            audienceType
            audienceFrom
            timesOfDay
            daysOfWeek
            forecastRequestedAt
            forecastAdgroups
            publishedAt
            ttdId
            conversionsEnabled
            trackingTagId
            pixelTrackingUrl
            ttdStatus
            dspIds
            audience
            bidlists
            ttdUpdatedAt
            activeUpdatedAt
            sfOpportunityId
            ctvSegments
            isRecurring
            isValid
            error
            isMultiDataGroups
            additionalBidLists
            postProcessors
            brandCampaignsId
            __typename
          }
          teamBrandCampaignId
          name
          fileName
          creativeType
          s3Key
          s3ThumbnailKey
          clickthroughUrl
          landingPageUrl
          inApp
          web
          ctv
          displayTargeting
          devices
          dspIds
          ttdId
          ttdStatus
          isValid
          error
          campaignCreativesId
          __typename
        }
        nextToken
        __typename
      }
      forecastRequestedAt
      forecastAdgroups
      publishedAt
      forecast {
        requestedAt
        createdAt
        impressions {
          max
          min
          __typename
        }
        reach {
          max
          min
          __typename
        }
        frequency {
          max
          min
          __typename
        }
        spend {
          max
          min
          __typename
        }
        results {
          adgroupType
          impressions {
            max
            min
            __typename
          }
          reach {
            max
            min
            __typename
          }
          frequency {
            max
            min
            __typename
          }
          spend {
            max
            min
            __typename
          }
          __typename
        }
        __typename
      }
      ttdId
      conversionsEnabled
      trackingTagId
      pixelTrackingUrl
      conversionEvents {
        type
        id
        __typename
      }
      ttdStatus
      dspIds
      audience
      bidlists
      markups {
        oMar
        tMar
        bMar
        __typename
      }
      summaryMetrics {
        items {
          summaryType
          impressions
          clicks
          views
          spend
          conversions
          graphs {
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          __typename
        }
        total
        __typename
      }
      ttdUpdatedAt
      activeUpdatedAt
      sfOpportunityId
      ctvSegments
      isRecurring
      isValid
      error
      isMultiDataGroups
      campaignPoliticalSettings {
        type
        __typename
      }
      additionalBidLists
      postProcessors
      brandCampaignsId
      __typename
    }
  }
`;
export const createCreative = /* GraphQL */ `
  mutation CreateCreative(
    $input: CreateCreativeInput!
    $condition: ModelCreativeConditionInput
  ) {
    createCreative(input: $input, condition: $condition) {
      id
      archived
      createdAt
      updatedAt
      uploadedAt
      publishedAt
      adminGroups
      viewerGroups
      organizationId
      teamBrandCampaign
      teamId
      brandId
      campaignId
      campaign {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        stoppedAt
        approvedAt
        lastRecurredAt
        organizationId
        teamId
        brandId
        brand {
          id
          archived
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          organizationId
          teamId
          team {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          advertiserId
          name
          websiteUrl
          logoUrl
          industryCategoryId
          politicalSettings {
            politicalType
            electionType
            status
            __typename
          }
          campaignPostProcessors
          config
          availableCredits
          paymentMethods {
            __typename
          }
          bMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          universalPixel {
            UniversalPixelId
            UniversalPixelName
            AdvertiserId
            __typename
          }
          pixelCode
          pixelTracking
          pixelAudienceSize
          pixelMappingSizes
          theme {
            primary
            secondary
            pallet
            __typename
          }
          campaignSummary {
            running
            stopped
            completed
            __typename
          }
          creativeSummary {
            audio
            display
            video
            __typename
          }
          reportSummary {
            forecast
            summary
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          campaigns {
            nextToken
            __typename
          }
          trackingTags {
            nextToken
            __typename
          }
          isValid
          error
          defaultStripeId
          underReview
          teamBrandsId
          __typename
        }
        status
        recurrenceWindow
        recurrenceBudget
        name
        goal
        budget
        originalBudget
        dailyBudget
        startDate
        endDate
        originalEndDate
        audienceType
        audienceFrom
        retargetingTags {
          dspId
          firstPartyDataId
          trackingTagId
          __typename
        }
        geoSegments {
          id
          segmentPackageId
          dspId
          name
          pathKey
          segmentType
          segmentGroup
          __typename
        }
        dmpSegments {
          id
          segmentPackageId
          dspId
          name
          pathKey
          segmentType
          segmentGroup
          __typename
        }
        inventorySegments {
          id
          segmentPackageId
          dspId
          name
          pathKey
          segmentType
          segmentGroup
          __typename
        }
        timesOfDay
        daysOfWeek
        creatives {
          items {
            id
            archived
            createdAt
            updatedAt
            uploadedAt
            publishedAt
            adminGroups
            viewerGroups
            organizationId
            teamBrandCampaign
            teamId
            brandId
            campaignId
            teamBrandCampaignId
            name
            fileName
            creativeType
            s3Key
            s3ThumbnailKey
            clickthroughUrl
            landingPageUrl
            inApp
            web
            ctv
            displayTargeting
            devices
            dspIds
            ttdId
            ttdStatus
            isValid
            error
            campaignCreativesId
            __typename
          }
          nextToken
          __typename
        }
        forecastRequestedAt
        forecastAdgroups
        publishedAt
        forecast {
          requestedAt
          createdAt
          impressions {
            max
            min
            __typename
          }
          reach {
            max
            min
            __typename
          }
          frequency {
            max
            min
            __typename
          }
          spend {
            max
            min
            __typename
          }
          results {
            adgroupType
            __typename
          }
          __typename
        }
        ttdId
        conversionsEnabled
        trackingTagId
        pixelTrackingUrl
        conversionEvents {
          type
          id
          __typename
        }
        ttdStatus
        dspIds
        audience
        bidlists
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        ttdUpdatedAt
        activeUpdatedAt
        sfOpportunityId
        ctvSegments
        isRecurring
        isValid
        error
        isMultiDataGroups
        campaignPoliticalSettings {
          type
          __typename
        }
        additionalBidLists
        postProcessors
        brandCampaignsId
        __typename
      }
      teamBrandCampaignId
      name
      fileName
      creativeType
      s3Key
      s3ThumbnailKey
      clickthroughUrl
      landingPageUrl
      inApp
      web
      ctv
      displayTargeting
      devices
      dspIds
      ttdId
      ttdStatus
      isValid
      error
      campaignCreativesId
      __typename
    }
  }
`;
export const updateCreative = /* GraphQL */ `
  mutation UpdateCreative(
    $input: UpdateCreativeInput!
    $condition: ModelCreativeConditionInput
  ) {
    updateCreative(input: $input, condition: $condition) {
      id
      archived
      createdAt
      updatedAt
      uploadedAt
      publishedAt
      adminGroups
      viewerGroups
      organizationId
      teamBrandCampaign
      teamId
      brandId
      campaignId
      campaign {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        stoppedAt
        approvedAt
        lastRecurredAt
        organizationId
        teamId
        brandId
        brand {
          id
          archived
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          organizationId
          teamId
          team {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          advertiserId
          name
          websiteUrl
          logoUrl
          industryCategoryId
          politicalSettings {
            politicalType
            electionType
            status
            __typename
          }
          campaignPostProcessors
          config
          availableCredits
          paymentMethods {
            __typename
          }
          bMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          universalPixel {
            UniversalPixelId
            UniversalPixelName
            AdvertiserId
            __typename
          }
          pixelCode
          pixelTracking
          pixelAudienceSize
          pixelMappingSizes
          theme {
            primary
            secondary
            pallet
            __typename
          }
          campaignSummary {
            running
            stopped
            completed
            __typename
          }
          creativeSummary {
            audio
            display
            video
            __typename
          }
          reportSummary {
            forecast
            summary
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          campaigns {
            nextToken
            __typename
          }
          trackingTags {
            nextToken
            __typename
          }
          isValid
          error
          defaultStripeId
          underReview
          teamBrandsId
          __typename
        }
        status
        recurrenceWindow
        recurrenceBudget
        name
        goal
        budget
        originalBudget
        dailyBudget
        startDate
        endDate
        originalEndDate
        audienceType
        audienceFrom
        retargetingTags {
          dspId
          firstPartyDataId
          trackingTagId
          __typename
        }
        geoSegments {
          id
          segmentPackageId
          dspId
          name
          pathKey
          segmentType
          segmentGroup
          __typename
        }
        dmpSegments {
          id
          segmentPackageId
          dspId
          name
          pathKey
          segmentType
          segmentGroup
          __typename
        }
        inventorySegments {
          id
          segmentPackageId
          dspId
          name
          pathKey
          segmentType
          segmentGroup
          __typename
        }
        timesOfDay
        daysOfWeek
        creatives {
          items {
            id
            archived
            createdAt
            updatedAt
            uploadedAt
            publishedAt
            adminGroups
            viewerGroups
            organizationId
            teamBrandCampaign
            teamId
            brandId
            campaignId
            teamBrandCampaignId
            name
            fileName
            creativeType
            s3Key
            s3ThumbnailKey
            clickthroughUrl
            landingPageUrl
            inApp
            web
            ctv
            displayTargeting
            devices
            dspIds
            ttdId
            ttdStatus
            isValid
            error
            campaignCreativesId
            __typename
          }
          nextToken
          __typename
        }
        forecastRequestedAt
        forecastAdgroups
        publishedAt
        forecast {
          requestedAt
          createdAt
          impressions {
            max
            min
            __typename
          }
          reach {
            max
            min
            __typename
          }
          frequency {
            max
            min
            __typename
          }
          spend {
            max
            min
            __typename
          }
          results {
            adgroupType
            __typename
          }
          __typename
        }
        ttdId
        conversionsEnabled
        trackingTagId
        pixelTrackingUrl
        conversionEvents {
          type
          id
          __typename
        }
        ttdStatus
        dspIds
        audience
        bidlists
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        ttdUpdatedAt
        activeUpdatedAt
        sfOpportunityId
        ctvSegments
        isRecurring
        isValid
        error
        isMultiDataGroups
        campaignPoliticalSettings {
          type
          __typename
        }
        additionalBidLists
        postProcessors
        brandCampaignsId
        __typename
      }
      teamBrandCampaignId
      name
      fileName
      creativeType
      s3Key
      s3ThumbnailKey
      clickthroughUrl
      landingPageUrl
      inApp
      web
      ctv
      displayTargeting
      devices
      dspIds
      ttdId
      ttdStatus
      isValid
      error
      campaignCreativesId
      __typename
    }
  }
`;
export const deleteCreative = /* GraphQL */ `
  mutation DeleteCreative(
    $input: DeleteCreativeInput!
    $condition: ModelCreativeConditionInput
  ) {
    deleteCreative(input: $input, condition: $condition) {
      id
      archived
      createdAt
      updatedAt
      uploadedAt
      publishedAt
      adminGroups
      viewerGroups
      organizationId
      teamBrandCampaign
      teamId
      brandId
      campaignId
      campaign {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        stoppedAt
        approvedAt
        lastRecurredAt
        organizationId
        teamId
        brandId
        brand {
          id
          archived
          adminGroups
          viewerGroups
          createdAt
          updatedAt
          organizationId
          teamId
          team {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            organizationId
            name
            websiteUrl
            logoUrl
            industryCategoryId
            config
            availableCredits
            tMar
            defaultBrandMarkup
            segmentPackages
            defaultStripeId
            organizationTeamsId
            __typename
          }
          advertiserId
          name
          websiteUrl
          logoUrl
          industryCategoryId
          politicalSettings {
            politicalType
            electionType
            status
            __typename
          }
          campaignPostProcessors
          config
          availableCredits
          paymentMethods {
            __typename
          }
          bMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          universalPixel {
            UniversalPixelId
            UniversalPixelName
            AdvertiserId
            __typename
          }
          pixelCode
          pixelTracking
          pixelAudienceSize
          pixelMappingSizes
          theme {
            primary
            secondary
            pallet
            __typename
          }
          campaignSummary {
            running
            stopped
            completed
            __typename
          }
          creativeSummary {
            audio
            display
            video
            __typename
          }
          reportSummary {
            forecast
            summary
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          campaigns {
            nextToken
            __typename
          }
          trackingTags {
            nextToken
            __typename
          }
          isValid
          error
          defaultStripeId
          underReview
          teamBrandsId
          __typename
        }
        status
        recurrenceWindow
        recurrenceBudget
        name
        goal
        budget
        originalBudget
        dailyBudget
        startDate
        endDate
        originalEndDate
        audienceType
        audienceFrom
        retargetingTags {
          dspId
          firstPartyDataId
          trackingTagId
          __typename
        }
        geoSegments {
          id
          segmentPackageId
          dspId
          name
          pathKey
          segmentType
          segmentGroup
          __typename
        }
        dmpSegments {
          id
          segmentPackageId
          dspId
          name
          pathKey
          segmentType
          segmentGroup
          __typename
        }
        inventorySegments {
          id
          segmentPackageId
          dspId
          name
          pathKey
          segmentType
          segmentGroup
          __typename
        }
        timesOfDay
        daysOfWeek
        creatives {
          items {
            id
            archived
            createdAt
            updatedAt
            uploadedAt
            publishedAt
            adminGroups
            viewerGroups
            organizationId
            teamBrandCampaign
            teamId
            brandId
            campaignId
            teamBrandCampaignId
            name
            fileName
            creativeType
            s3Key
            s3ThumbnailKey
            clickthroughUrl
            landingPageUrl
            inApp
            web
            ctv
            displayTargeting
            devices
            dspIds
            ttdId
            ttdStatus
            isValid
            error
            campaignCreativesId
            __typename
          }
          nextToken
          __typename
        }
        forecastRequestedAt
        forecastAdgroups
        publishedAt
        forecast {
          requestedAt
          createdAt
          impressions {
            max
            min
            __typename
          }
          reach {
            max
            min
            __typename
          }
          frequency {
            max
            min
            __typename
          }
          spend {
            max
            min
            __typename
          }
          results {
            adgroupType
            __typename
          }
          __typename
        }
        ttdId
        conversionsEnabled
        trackingTagId
        pixelTrackingUrl
        conversionEvents {
          type
          id
          __typename
        }
        ttdStatus
        dspIds
        audience
        bidlists
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        ttdUpdatedAt
        activeUpdatedAt
        sfOpportunityId
        ctvSegments
        isRecurring
        isValid
        error
        isMultiDataGroups
        campaignPoliticalSettings {
          type
          __typename
        }
        additionalBidLists
        postProcessors
        brandCampaignsId
        __typename
      }
      teamBrandCampaignId
      name
      fileName
      creativeType
      s3Key
      s3ThumbnailKey
      clickthroughUrl
      landingPageUrl
      inApp
      web
      ctv
      displayTargeting
      devices
      dspIds
      ttdId
      ttdStatus
      isValid
      error
      campaignCreativesId
      __typename
    }
  }
`;
export const createCredit = /* GraphQL */ `
  mutation CreateCredit(
    $input: CreateCreditInput!
    $condition: ModelCreditConditionInput
  ) {
    createCredit(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      adminGroups
      viewerGroups
      userId
      organizationId
      teamId
      brandId
      campaignId
      chargeType
      chargeId
      amountIntended
      amount
      status
      metadata
      __typename
    }
  }
`;
export const updateCredit = /* GraphQL */ `
  mutation UpdateCredit(
    $input: UpdateCreditInput!
    $condition: ModelCreditConditionInput
  ) {
    updateCredit(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      adminGroups
      viewerGroups
      userId
      organizationId
      teamId
      brandId
      campaignId
      chargeType
      chargeId
      amountIntended
      amount
      status
      metadata
      __typename
    }
  }
`;
export const deleteCredit = /* GraphQL */ `
  mutation DeleteCredit(
    $input: DeleteCreditInput!
    $condition: ModelCreditConditionInput
  ) {
    deleteCredit(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      adminGroups
      viewerGroups
      userId
      organizationId
      teamId
      brandId
      campaignId
      chargeType
      chargeId
      amountIntended
      amount
      status
      metadata
      __typename
    }
  }
`;
export const createTrackingTag = /* GraphQL */ `
  mutation CreateTrackingTag(
    $input: CreateTrackingTagInput!
    $condition: ModelTrackingTagConditionInput
  ) {
    createTrackingTag(input: $input, condition: $condition) {
      id
      archived
      trackingTagType
      adminGroups
      viewerGroups
      createdAt
      updatedAt
      errorNotifiedAt
      organizationId
      teamId
      brandId
      dspIds
      status
      ttdId
      name
      pixelCode
      pixelAudienceSize
      pixelUrl
      remainingDays
      brand {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        organizationId
        teamId
        team {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          name
          websiteUrl
          logoUrl
          industryCategoryId
          config
          availableCredits
          paymentMethods {
            __typename
          }
          tMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultBrandMarkup
          theme {
            primary
            secondary
            pallet
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          brands {
            nextToken
            __typename
          }
          defaultStripeId
          organizationTeamsId
          __typename
        }
        advertiserId
        name
        websiteUrl
        logoUrl
        industryCategoryId
        politicalSettings {
          politicalType
          electionType
          candidate {
            PoliticalDataId
            CandidateName
            ElectionState
            PayingEntityName
            PayingEntityAddress
            PayingEntityEmailAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            GeoDescription
            AudienceDescription
            DisclaimerNotice
            FileLocationInS3
            FederalVerificationId
            StateVerificationId
            IsAdvertiserIEC
            __typename
          }
          status
          ballotMeasureProfile {
            PayingEntityName
            PayingEntityAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            ElectionState
            __typename
          }
          __typename
        }
        campaignPostProcessors
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        bMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        universalPixel {
          UniversalPixelMappings {
            __typename
          }
          UniversalPixelId
          UniversalPixelName
          AdvertiserId
          __typename
        }
        pixelCode
        pixelTracking
        pixelAudienceSize
        pixelMappingSizes
        theme {
          primary
          secondary
          pallet
          __typename
        }
        campaignSummary {
          running
          stopped
          completed
          __typename
        }
        creativeSummary {
          audio
          display
          video
          __typename
        }
        reportSummary {
          forecast
          summary
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        campaigns {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            stoppedAt
            approvedAt
            lastRecurredAt
            organizationId
            teamId
            brandId
            status
            recurrenceWindow
            recurrenceBudget
            name
            goal
            budget
            originalBudget
            dailyBudget
            startDate
            endDate
            originalEndDate
            audienceType
            audienceFrom
            timesOfDay
            daysOfWeek
            forecastRequestedAt
            forecastAdgroups
            publishedAt
            ttdId
            conversionsEnabled
            trackingTagId
            pixelTrackingUrl
            ttdStatus
            dspIds
            audience
            bidlists
            ttdUpdatedAt
            activeUpdatedAt
            sfOpportunityId
            ctvSegments
            isRecurring
            isValid
            error
            isMultiDataGroups
            additionalBidLists
            postProcessors
            brandCampaignsId
            __typename
          }
          nextToken
          __typename
        }
        trackingTags {
          items {
            id
            archived
            trackingTagType
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            errorNotifiedAt
            organizationId
            teamId
            brandId
            dspIds
            status
            ttdId
            name
            pixelCode
            pixelAudienceSize
            pixelUrl
            remainingDays
            piiType
            region
            retainPii
            brandTrackingTagsId
            __typename
          }
          nextToken
          __typename
        }
        isValid
        error
        defaultStripeId
        underReview
        teamBrandsId
        __typename
      }
      piiType
      region
      retainPii
      brandTrackingTagsId
      __typename
    }
  }
`;
export const updateTrackingTag = /* GraphQL */ `
  mutation UpdateTrackingTag(
    $input: UpdateTrackingTagInput!
    $condition: ModelTrackingTagConditionInput
  ) {
    updateTrackingTag(input: $input, condition: $condition) {
      id
      archived
      trackingTagType
      adminGroups
      viewerGroups
      createdAt
      updatedAt
      errorNotifiedAt
      organizationId
      teamId
      brandId
      dspIds
      status
      ttdId
      name
      pixelCode
      pixelAudienceSize
      pixelUrl
      remainingDays
      brand {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        organizationId
        teamId
        team {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          name
          websiteUrl
          logoUrl
          industryCategoryId
          config
          availableCredits
          paymentMethods {
            __typename
          }
          tMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultBrandMarkup
          theme {
            primary
            secondary
            pallet
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          brands {
            nextToken
            __typename
          }
          defaultStripeId
          organizationTeamsId
          __typename
        }
        advertiserId
        name
        websiteUrl
        logoUrl
        industryCategoryId
        politicalSettings {
          politicalType
          electionType
          candidate {
            PoliticalDataId
            CandidateName
            ElectionState
            PayingEntityName
            PayingEntityAddress
            PayingEntityEmailAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            GeoDescription
            AudienceDescription
            DisclaimerNotice
            FileLocationInS3
            FederalVerificationId
            StateVerificationId
            IsAdvertiserIEC
            __typename
          }
          status
          ballotMeasureProfile {
            PayingEntityName
            PayingEntityAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            ElectionState
            __typename
          }
          __typename
        }
        campaignPostProcessors
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        bMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        universalPixel {
          UniversalPixelMappings {
            __typename
          }
          UniversalPixelId
          UniversalPixelName
          AdvertiserId
          __typename
        }
        pixelCode
        pixelTracking
        pixelAudienceSize
        pixelMappingSizes
        theme {
          primary
          secondary
          pallet
          __typename
        }
        campaignSummary {
          running
          stopped
          completed
          __typename
        }
        creativeSummary {
          audio
          display
          video
          __typename
        }
        reportSummary {
          forecast
          summary
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        campaigns {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            stoppedAt
            approvedAt
            lastRecurredAt
            organizationId
            teamId
            brandId
            status
            recurrenceWindow
            recurrenceBudget
            name
            goal
            budget
            originalBudget
            dailyBudget
            startDate
            endDate
            originalEndDate
            audienceType
            audienceFrom
            timesOfDay
            daysOfWeek
            forecastRequestedAt
            forecastAdgroups
            publishedAt
            ttdId
            conversionsEnabled
            trackingTagId
            pixelTrackingUrl
            ttdStatus
            dspIds
            audience
            bidlists
            ttdUpdatedAt
            activeUpdatedAt
            sfOpportunityId
            ctvSegments
            isRecurring
            isValid
            error
            isMultiDataGroups
            additionalBidLists
            postProcessors
            brandCampaignsId
            __typename
          }
          nextToken
          __typename
        }
        trackingTags {
          items {
            id
            archived
            trackingTagType
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            errorNotifiedAt
            organizationId
            teamId
            brandId
            dspIds
            status
            ttdId
            name
            pixelCode
            pixelAudienceSize
            pixelUrl
            remainingDays
            piiType
            region
            retainPii
            brandTrackingTagsId
            __typename
          }
          nextToken
          __typename
        }
        isValid
        error
        defaultStripeId
        underReview
        teamBrandsId
        __typename
      }
      piiType
      region
      retainPii
      brandTrackingTagsId
      __typename
    }
  }
`;
export const deleteTrackingTag = /* GraphQL */ `
  mutation DeleteTrackingTag(
    $input: DeleteTrackingTagInput!
    $condition: ModelTrackingTagConditionInput
  ) {
    deleteTrackingTag(input: $input, condition: $condition) {
      id
      archived
      trackingTagType
      adminGroups
      viewerGroups
      createdAt
      updatedAt
      errorNotifiedAt
      organizationId
      teamId
      brandId
      dspIds
      status
      ttdId
      name
      pixelCode
      pixelAudienceSize
      pixelUrl
      remainingDays
      brand {
        id
        archived
        adminGroups
        viewerGroups
        createdAt
        updatedAt
        organizationId
        teamId
        team {
          id
          archived
          adminGroups
          viewerGroups
          memberGroups
          createdAt
          updatedAt
          organizationId
          organization {
            id
            archived
            adminGroups
            viewerGroups
            memberGroups
            createdAt
            updatedAt
            name
            logoUrl
            accountDomain
            accountSubdomain
            accountConfig
            config
            availableCredits
            oMar
            defaultTeamMarkup
            segmentPackages
            __typename
          }
          name
          websiteUrl
          logoUrl
          industryCategoryId
          config
          availableCredits
          paymentMethods {
            __typename
          }
          tMar
          markups {
            oMar
            tMar
            bMar
            __typename
          }
          defaultBrandMarkup
          theme {
            primary
            secondary
            pallet
            __typename
          }
          summaryMetrics {
            total
            __typename
          }
          segmentPackages
          brands {
            nextToken
            __typename
          }
          defaultStripeId
          organizationTeamsId
          __typename
        }
        advertiserId
        name
        websiteUrl
        logoUrl
        industryCategoryId
        politicalSettings {
          politicalType
          electionType
          candidate {
            PoliticalDataId
            CandidateName
            ElectionState
            PayingEntityName
            PayingEntityAddress
            PayingEntityEmailAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            GeoDescription
            AudienceDescription
            DisclaimerNotice
            FileLocationInS3
            FederalVerificationId
            StateVerificationId
            IsAdvertiserIEC
            __typename
          }
          status
          ballotMeasureProfile {
            PayingEntityName
            PayingEntityAddress
            PayingEntityExecutiveName
            PayingEntityExecutiveTitle
            ElectionState
            __typename
          }
          __typename
        }
        campaignPostProcessors
        config
        availableCredits
        paymentMethods {
          items {
            stripeId
            nickname
            lastFour
            cardType
            default
            __typename
          }
          __typename
        }
        bMar
        markups {
          oMar
          tMar
          bMar
          __typename
        }
        universalPixel {
          UniversalPixelMappings {
            __typename
          }
          UniversalPixelId
          UniversalPixelName
          AdvertiserId
          __typename
        }
        pixelCode
        pixelTracking
        pixelAudienceSize
        pixelMappingSizes
        theme {
          primary
          secondary
          pallet
          __typename
        }
        campaignSummary {
          running
          stopped
          completed
          __typename
        }
        creativeSummary {
          audio
          display
          video
          __typename
        }
        reportSummary {
          forecast
          summary
          __typename
        }
        summaryMetrics {
          items {
            summaryType
            impressions
            clicks
            views
            spend
            conversions
            __typename
          }
          total
          __typename
        }
        segmentPackages
        campaigns {
          items {
            id
            archived
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            stoppedAt
            approvedAt
            lastRecurredAt
            organizationId
            teamId
            brandId
            status
            recurrenceWindow
            recurrenceBudget
            name
            goal
            budget
            originalBudget
            dailyBudget
            startDate
            endDate
            originalEndDate
            audienceType
            audienceFrom
            timesOfDay
            daysOfWeek
            forecastRequestedAt
            forecastAdgroups
            publishedAt
            ttdId
            conversionsEnabled
            trackingTagId
            pixelTrackingUrl
            ttdStatus
            dspIds
            audience
            bidlists
            ttdUpdatedAt
            activeUpdatedAt
            sfOpportunityId
            ctvSegments
            isRecurring
            isValid
            error
            isMultiDataGroups
            additionalBidLists
            postProcessors
            brandCampaignsId
            __typename
          }
          nextToken
          __typename
        }
        trackingTags {
          items {
            id
            archived
            trackingTagType
            adminGroups
            viewerGroups
            createdAt
            updatedAt
            errorNotifiedAt
            organizationId
            teamId
            brandId
            dspIds
            status
            ttdId
            name
            pixelCode
            pixelAudienceSize
            pixelUrl
            remainingDays
            piiType
            region
            retainPii
            brandTrackingTagsId
            __typename
          }
          nextToken
          __typename
        }
        isValid
        error
        defaultStripeId
        underReview
        teamBrandsId
        __typename
      }
      piiType
      region
      retainPii
      brandTrackingTagsId
      __typename
    }
  }
`;
export const createFeatureFlag = /* GraphQL */ `
  mutation CreateFeatureFlag(
    $input: CreateFeatureFlagInput!
    $condition: ModelFeatureFlagConditionInput
  ) {
    createFeatureFlag(input: $input, condition: $condition) {
      id
      value
      internal {
        brandzookaEmails
        __typename
      }
      staticAuthRoles {
        staticAuthRole
        value
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFeatureFlag = /* GraphQL */ `
  mutation UpdateFeatureFlag(
    $input: UpdateFeatureFlagInput!
    $condition: ModelFeatureFlagConditionInput
  ) {
    updateFeatureFlag(input: $input, condition: $condition) {
      id
      value
      internal {
        brandzookaEmails
        __typename
      }
      staticAuthRoles {
        staticAuthRole
        value
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFeatureFlag = /* GraphQL */ `
  mutation DeleteFeatureFlag(
    $input: DeleteFeatureFlagInput!
    $condition: ModelFeatureFlagConditionInput
  ) {
    deleteFeatureFlag(input: $input, condition: $condition) {
      id
      value
      internal {
        brandzookaEmails
        __typename
      }
      staticAuthRoles {
        staticAuthRole
        value
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createApiKey = /* GraphQL */ `
  mutation CreateApiKey(
    $input: CreateApiKeyInput!
    $condition: ModelApiKeyConditionInput
  ) {
    createApiKey(input: $input, condition: $condition) {
      id
      apiKeyId
      apiKey
      api
      name
      description
      brandId
      teamId
      organizationId
      adminGroups
      viewerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateApiKey = /* GraphQL */ `
  mutation UpdateApiKey(
    $input: UpdateApiKeyInput!
    $condition: ModelApiKeyConditionInput
  ) {
    updateApiKey(input: $input, condition: $condition) {
      id
      apiKeyId
      apiKey
      api
      name
      description
      brandId
      teamId
      organizationId
      adminGroups
      viewerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteApiKey = /* GraphQL */ `
  mutation DeleteApiKey(
    $input: DeleteApiKeyInput!
    $condition: ModelApiKeyConditionInput
  ) {
    deleteApiKey(input: $input, condition: $condition) {
      id
      apiKeyId
      apiKey
      api
      name
      description
      brandId
      teamId
      organizationId
      adminGroups
      viewerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createExecutionSummary = /* GraphQL */ `
  mutation CreateExecutionSummary(
    $input: CreateExecutionSummaryInput!
    $condition: ModelExecutionSummaryConditionInput
  ) {
    createExecutionSummary(input: $input, condition: $condition) {
      id
      type
      date
      successCount
      failedExecutions {
        executionId
        executionDate
        campaignId
        brandId
        teamId
        organizationId
        campaignName
        brandName
        teamName
        organizationName
        error
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateExecutionSummary = /* GraphQL */ `
  mutation UpdateExecutionSummary(
    $input: UpdateExecutionSummaryInput!
    $condition: ModelExecutionSummaryConditionInput
  ) {
    updateExecutionSummary(input: $input, condition: $condition) {
      id
      type
      date
      successCount
      failedExecutions {
        executionId
        executionDate
        campaignId
        brandId
        teamId
        organizationId
        campaignName
        brandName
        teamName
        organizationName
        error
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteExecutionSummary = /* GraphQL */ `
  mutation DeleteExecutionSummary(
    $input: DeleteExecutionSummaryInput!
    $condition: ModelExecutionSummaryConditionInput
  ) {
    deleteExecutionSummary(input: $input, condition: $condition) {
      id
      type
      date
      successCount
      failedExecutions {
        executionId
        executionDate
        campaignId
        brandId
        teamId
        organizationId
        campaignName
        brandName
        teamName
        organizationName
        error
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCampaignForecast = /* GraphQL */ `
  mutation CreateCampaignForecast(
    $input: CreateCampaignForecastInput!
    $condition: ModelCampaignForecastConditionInput
  ) {
    createCampaignForecast(input: $input, condition: $condition) {
      id
      campaignId
      campaignBudget
      brandId
      teamId
      organizationId
      adminGroups
      viewerGroups
      adgroupType
      avgBidCpm
      timeWindowInDays
      metrics {
        impressions {
          max
          min
          __typename
        }
        reach {
          max
          min
          __typename
        }
        frequency {
          max
          min
          __typename
        }
        spend {
          max
          min
          __typename
        }
        cpm {
          max
          min
          __typename
        }
        __typename
      }
      budgetMetrics {
        impressions {
          max
          min
          __typename
        }
        reach {
          max
          min
          __typename
        }
        frequency {
          max
          min
          __typename
        }
        spend {
          max
          min
          __typename
        }
        cpm {
          max
          min
          __typename
        }
        __typename
      }
      deviceMaxReach
      underSpend
      startDate
      endDate
      geoSegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      dmpSegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      inventorySegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      ctvSegments
      creatives {
        id
        updatedAt
        creativeType
        web
        ctv
        displayTargeting
        archived
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCampaignForecast = /* GraphQL */ `
  mutation UpdateCampaignForecast(
    $input: UpdateCampaignForecastInput!
    $condition: ModelCampaignForecastConditionInput
  ) {
    updateCampaignForecast(input: $input, condition: $condition) {
      id
      campaignId
      campaignBudget
      brandId
      teamId
      organizationId
      adminGroups
      viewerGroups
      adgroupType
      avgBidCpm
      timeWindowInDays
      metrics {
        impressions {
          max
          min
          __typename
        }
        reach {
          max
          min
          __typename
        }
        frequency {
          max
          min
          __typename
        }
        spend {
          max
          min
          __typename
        }
        cpm {
          max
          min
          __typename
        }
        __typename
      }
      budgetMetrics {
        impressions {
          max
          min
          __typename
        }
        reach {
          max
          min
          __typename
        }
        frequency {
          max
          min
          __typename
        }
        spend {
          max
          min
          __typename
        }
        cpm {
          max
          min
          __typename
        }
        __typename
      }
      deviceMaxReach
      underSpend
      startDate
      endDate
      geoSegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      dmpSegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      inventorySegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      ctvSegments
      creatives {
        id
        updatedAt
        creativeType
        web
        ctv
        displayTargeting
        archived
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCampaignForecast = /* GraphQL */ `
  mutation DeleteCampaignForecast(
    $input: DeleteCampaignForecastInput!
    $condition: ModelCampaignForecastConditionInput
  ) {
    deleteCampaignForecast(input: $input, condition: $condition) {
      id
      campaignId
      campaignBudget
      brandId
      teamId
      organizationId
      adminGroups
      viewerGroups
      adgroupType
      avgBidCpm
      timeWindowInDays
      metrics {
        impressions {
          max
          min
          __typename
        }
        reach {
          max
          min
          __typename
        }
        frequency {
          max
          min
          __typename
        }
        spend {
          max
          min
          __typename
        }
        cpm {
          max
          min
          __typename
        }
        __typename
      }
      budgetMetrics {
        impressions {
          max
          min
          __typename
        }
        reach {
          max
          min
          __typename
        }
        frequency {
          max
          min
          __typename
        }
        spend {
          max
          min
          __typename
        }
        cpm {
          max
          min
          __typename
        }
        __typename
      }
      deviceMaxReach
      underSpend
      startDate
      endDate
      geoSegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      dmpSegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      inventorySegments {
        id
        segmentPackageId
        dspId
        name
        pathKey
        segmentType
        segmentGroup
        __typename
      }
      ctvSegments
      creatives {
        id
        updatedAt
        creativeType
        web
        ctv
        displayTargeting
        archived
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAudience = /* GraphQL */ `
  mutation CreateAudience(
    $input: CreateAudienceInput!
    $condition: ModelAudienceConditionInput
  ) {
    createAudience(input: $input, condition: $condition) {
      id
      dspId
      audienceType
      name
      description
      brandId
      teamId
      organizationId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAudience = /* GraphQL */ `
  mutation UpdateAudience(
    $input: UpdateAudienceInput!
    $condition: ModelAudienceConditionInput
  ) {
    updateAudience(input: $input, condition: $condition) {
      id
      dspId
      audienceType
      name
      description
      brandId
      teamId
      organizationId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAudience = /* GraphQL */ `
  mutation DeleteAudience(
    $input: DeleteAudienceInput!
    $condition: ModelAudienceConditionInput
  ) {
    deleteAudience(input: $input, condition: $condition) {
      id
      dspId
      audienceType
      name
      description
      brandId
      teamId
      organizationId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBidlist = /* GraphQL */ `
  mutation CreateBidlist(
    $input: CreateBidlistInput!
    $condition: ModelBidlistConditionInput
  ) {
    createBidlist(input: $input, condition: $condition) {
      id
      dspId
      type
      category
      adjustmentType
      name
      description
      brandId
      teamId
      organizationId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBidlist = /* GraphQL */ `
  mutation UpdateBidlist(
    $input: UpdateBidlistInput!
    $condition: ModelBidlistConditionInput
  ) {
    updateBidlist(input: $input, condition: $condition) {
      id
      dspId
      type
      category
      adjustmentType
      name
      description
      brandId
      teamId
      organizationId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBidlist = /* GraphQL */ `
  mutation DeleteBidlist(
    $input: DeleteBidlistInput!
    $condition: ModelBidlistConditionInput
  ) {
    deleteBidlist(input: $input, condition: $condition) {
      id
      dspId
      type
      category
      adjustmentType
      name
      description
      brandId
      teamId
      organizationId
      createdAt
      updatedAt
      __typename
    }
  }
`;
